/* ==========================================================================
   STICK'IT — moteur d'interface
   Curseur traceur de découpe · fumée en canvas · transitions · panier
   Aucune dépendance externe.
   ========================================================================== */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover:hover) and (pointer:fine)').matches;
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var lerp = function (a, b, t) { return a + (b - a) * t; };
  var clamp = function (v, a, b) { return Math.max(a, Math.min(b, v)); };

  /* ----------------------------------------------------------------------
     Stockage : localStorage si disponible, sinon mémoire
     ---------------------------------------------------------------------- */
  var Store = (function () {
    var mem = {}, ok = false;
    try { localStorage.setItem('__t', '1'); localStorage.removeItem('__t'); ok = true; } catch (e) { ok = false; }
    return {
      get: function (k) { try { return ok ? localStorage.getItem(k) : mem[k]; } catch (e) { return mem[k]; } },
      set: function (k, v) { try { ok ? localStorage.setItem(k, v) : (mem[k] = v); } catch (e) { mem[k] = v; } }
    };
  })();

  /* ======================================================================
     1. CURSEUR « TRACEUR DE DÉCOUPE »
     Croix de visée + anneau pointillé rotatif + traînée qui redessine
     le chemin de la lame derrière la souris.
     ====================================================================== */
  function initCursor() {
    // Le curseur reste actif même si le système demande moins d'animations :
    // dans ce cas on retire la traînée et le lissage, pas le curseur lui-même.
    if (!fine) return;
    var root = document.documentElement;
    root.classList.add('has-cursor');
    if (reduced) root.classList.add('cursor-calm');

    // traînée (désactivée en mode animations réduites)
    var trail = null, tc = null;
    var dpr = Math.min(window.devicePixelRatio || 1, 1.5);
    function sizeTrail() {
      if (!trail) return;
      trail.width = innerWidth * dpr; trail.height = innerHeight * dpr;
      trail.style.width = innerWidth + 'px'; trail.style.height = innerHeight + 'px';
      tc.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    if (!reduced) {
      trail = document.createElement('canvas');
      trail.id = 'cut-trail';
      document.body.appendChild(trail);
      tc = trail.getContext('2d');
      sizeTrail();
      addEventListener('resize', sizeTrail);
    }

    // curseur
    var cross = document.createElement('div');
    cross.className = 'cur cur-cross'; cross.innerHTML = '<i></i>';
    var ring = document.createElement('div');
    ring.className = 'cur cur-ring';
    ring.innerHTML = '<svg viewBox="0 0 100 100"><circle cx="50" cy="50" r="48"/></svg>';
    var pill = document.createElement('div');
    pill.className = 'cur cur-pill'; pill.innerHTML = '<span>Voir</span>';
    document.body.appendChild(ring); document.body.appendChild(pill); document.body.appendChild(cross);

    var mx = innerWidth / 2, my = innerHeight / 2;
    var cx = mx, cy = my, rx = mx, ry = my, px = mx, py = my;
    var ready = false;
    var pts = [];          // chemin de coupe
    var sparks = [];       // étincelles au clic

    addEventListener('mousemove', function (ev) {
      mx = ev.clientX; my = ev.clientY;
      if (!ready) { ready = true; cx = rx = px = mx; cy = ry = py = my; root.classList.add('cursor-ready'); }
      pts.push({ x: mx, y: my, t: performance.now() });
      if (pts.length > 46) pts.shift();
    }, { passive: true });

    addEventListener('mouseout', function (ev) { if (!ev.relatedTarget) root.classList.remove('cursor-ready'); });
    addEventListener('mouseover', function () { if (ready) root.classList.add('cursor-ready'); }, { passive: true });
    addEventListener('mousedown', function () {
      root.classList.add('cursor-down');
      for (var i = 0; i < 12; i++) {
        var a = Math.random() * Math.PI * 2, s = 1.6 + Math.random() * 3.4;
        sparks.push({ x: mx, y: my, vx: Math.cos(a) * s, vy: Math.sin(a) * s, life: 1 });
      }
    });
    addEventListener('mouseup', function () { root.classList.remove('cursor-down'); });

    var dash = 0, drawn = true, hid = false, hidAt = 0;
    (function frame() {
      var now = performance.now();

      // en mode apaisé le curseur colle exactement à la souris, sans inertie
      var kC = reduced ? 1 : 0.5, kR = reduced ? 1 : 0.14, kP = reduced ? 1 : 0.2;
      cx = lerp(cx, mx, kC); cy = lerp(cy, my, kC);
      rx = lerp(rx, mx, kR); ry = lerp(ry, my, kR);
      px = lerp(px, mx, kP); py = lerp(py, my, kP);
      cross.style.transform = 'translate3d(' + cx + 'px,' + cy + 'px,0)';
      ring.style.transform = 'translate3d(' + rx + 'px,' + ry + 'px,0)';
      pill.style.transform = 'translate3d(' + px + 'px,' + py + 'px,0)';

      if (!tc) { requestAnimationFrame(frame); return; }
      // calque masqué (curseur du skin) ou rien à dessiner : on n'efface pas tout l'écran à chaque image
      while (pts.length && now - pts[0].t > 620) pts.shift();
      if (now - hidAt > 1000) { hidAt = now; hid = getComputedStyle(trail).display === 'none'; }   // relu 1×/s seulement
      if (hid) { pts.length = 0; sparks.length = 0; }
      if (pts.length <= 2 && !sparks.length) {
        if (drawn) { tc.clearRect(0, 0, innerWidth, innerHeight); drawn = false; }
        requestAnimationFrame(frame); return;
      }
      tc.clearRect(0, 0, innerWidth, innerHeight); drawn = true;

      // chemin de coupe : segments pointillés dont l'opacité décroît avec l'âge
      if (pts.length > 2) {
        dash = (dash + 1.4) % 14;
        tc.lineCap = 'round';
        tc.setLineDash([5, 7]);
        tc.lineDashOffset = -dash;
        for (var i = 1; i < pts.length; i++) {
          var age = (now - pts[i].t) / 620;
          var a = clamp(1 - age, 0, 1);
          tc.strokeStyle = (document.body.getAttribute('data-amb')==='obsaners'?'rgba(255,0,79,':'rgba(248,156,8,') + (a * 0.62).toFixed(3) + ')';
          tc.lineWidth = 0.7 + a * 1.5;
          tc.beginPath();
          tc.moveTo(pts[i - 1].x, pts[i - 1].y);
          tc.lineTo(pts[i].x, pts[i].y);
          tc.stroke();
        }
        tc.setLineDash([]);
      }

      // étincelles de clic
      if (sparks.length) {
        tc.globalCompositeOperation = 'lighter';
        for (var k = sparks.length - 1; k >= 0; k--) {
          var s = sparks[k];
          s.x += s.vx; s.y += s.vy; s.vx *= 0.93; s.vy *= 0.93; s.life -= 0.038;
          if (s.life <= 0) { sparks.splice(k, 1); continue; }
          tc.fillStyle = (document.body.getAttribute('data-amb')==='obsaners'?'rgba(255,60,110,':'rgba(255,184,77,') + s.life.toFixed(3) + ')';
          tc.beginPath(); tc.arc(s.x, s.y, 1.8 * s.life + 0.4, 0, 6.283); tc.fill();
        }
        tc.globalCompositeOperation = 'source-over';
      }

      requestAnimationFrame(frame);
    })();

    var VIEW = '.pcard-link,.ccard,.obs-item,.gal-thumbs button,.perk,.case';
    var LINK = 'a,button,summary,.chip,.tier,label,select,.swatches button,.sizes button';
    var TEXT = 'input[type=text],input[type=email],input[type=tel],input[type=number],textarea';
    document.addEventListener('mouseover', function (ev) {
      var t = ev.target;
      if (!t || !t.closest) return;
      var v = !!t.closest(VIEW), x = !!t.closest(TEXT);
      root.classList.toggle('cursor-view', v);
      root.classList.toggle('cursor-text', x);
      root.classList.toggle('cursor-link', !v && !x && !!t.closest(LINK));
    }, { passive: true });
  }

  /* ======================================================================
     2. FUMÉE EN CANVAS
     ====================================================================== */
  function makeSprite(size, r, g, b, peak) {
    var c = document.createElement('canvas');
    c.width = c.height = size;
    var x = c.getContext('2d');
    var grd = x.createRadialGradient(size / 2, size / 2, 0, size / 2, size / 2, size / 2);
    grd.addColorStop(0, 'rgba(' + r + ',' + g + ',' + b + ',' + peak + ')');
    grd.addColorStop(0.32, 'rgba(' + r + ',' + g + ',' + b + ',' + (peak * 0.42).toFixed(3) + ')');
    grd.addColorStop(0.7, 'rgba(' + r + ',' + g + ',' + b + ',' + (peak * 0.1).toFixed(3) + ')');
    grd.addColorStop(1, 'rgba(' + r + ',' + g + ',' + b + ',0)');
    x.fillStyle = grd; x.fillRect(0, 0, size, size);
    return c;
  }

  function Smoke(canvas, o) {
    o = o || {};
    var ctx = canvas.getContext('2d');
    var sprite = makeSprite(256, o.r != null ? o.r : 255, o.g != null ? o.g : 12, o.b != null ? o.b : 72,
                            o.peak != null ? o.peak : 0.55);
    var parts = [], W = 1, H = 1, running = false, vis = true, looping = false;
    // fumée = dégradés flous : rendue à demi-résolution puis agrandie par le navigateur (invisible à l'œil,
    // ~4× moins de pixels à peindre). Moins de nappes sur téléphone.
    var dpr = 0.5;
    var count = o.count || 26;
    if (!fine) count = Math.round(count * 0.6);
    // pause hors écran / onglet masqué, reprise au retour
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        vis = en[0].isIntersecting;
        if (vis && running && !looping) { looping = true; requestAnimationFrame(draw); }
      }, { rootMargin: '80px 0px' }).observe(canvas);
    }
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden && running && vis && !looping) { looping = true; requestAnimationFrame(draw); }
    });

    function size() {
      var r = canvas.getBoundingClientRect();
      W = Math.max(1, r.width); H = Math.max(1, r.height);
      canvas.width = Math.round(W * dpr); canvas.height = Math.round(H * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }

    function make(fromBottom) {
      var s = (o.min || 260) + Math.random() * ((o.max || 620) - (o.min || 260));
      return {
        x: Math.random() * W,
        // au déclenchement les particules partent du bas et montent tout de suite
        y: fromBottom ? H + s * 0.35 * Math.random() : Math.random() * H,
        s: s,
        vx: (Math.random() - 0.5) * (o.drift || 0.5),
        vy: -((o.rise || 1.1) * (0.55 + Math.random() * 0.9)),
        a: 0,
        tgt: (o.alphaMin || 0.4) + Math.random() * ((o.alphaMax || 1) - (o.alphaMin || 0.4)),
        ramp: 0.045 + Math.random() * 0.05,
        rot: Math.random() * 6.283,
        vr: (Math.random() - 0.5) * 0.004
      };
    }

    function draw() {
      if (!running || !vis || document.hidden) { looping = false; return; }
      ctx.clearRect(0, 0, W, H);
      ctx.globalCompositeOperation = 'lighter';
      for (var i = 0; i < parts.length; i++) {
        var p = parts[i];
        p.x += p.vx; p.y += p.vy; p.rot += p.vr;
        p.a += (p.tgt - p.a) * p.ramp;
        // recyclage dès que la particule sort par le haut
        if (p.y + p.s * 0.5 < -30) { parts[i] = make(true); continue; }
        if (p.x < -p.s) p.x = W + p.s * 0.5;
        if (p.x > W + p.s) p.x = -p.s * 0.5;
        ctx.save();
        ctx.globalAlpha = clamp(p.a, 0, 1);
        ctx.translate(p.x, p.y); ctx.rotate(p.rot);
        ctx.drawImage(sprite, -p.s / 2, -p.s / 2, p.s, p.s);
        ctx.restore();
      }
      requestAnimationFrame(draw);
    }

    size();
    addEventListener('resize', size);
    return {
      start: function (fromBottom) {
        if (running) return;
        size();
        parts = [];
        for (var i = 0; i < count; i++) parts.push(make(fromBottom));
        // pour l'ambiance, on amorce les particules déjà « installées »
        if (!fromBottom) parts.forEach(function (p) { p.a = p.tgt * 0.7; });
        running = true; looping = true; draw();
      },
      stop: function () { running = false; },
      // Mouvement réduit demandé : on pose une nappe fixe plutôt que rien.
      still: function () {
        size();
        parts = [];
        for (var i = 0; i < count; i++) { var q = make(false); q.a = q.tgt * 0.8; parts.push(q); }
        ctx.clearRect(0, 0, W, H);
        ctx.globalCompositeOperation = 'lighter';
        parts.forEach(function (p) {
          ctx.save();
          ctx.globalAlpha = clamp(p.a, 0, 1);
          ctx.translate(p.x, p.y); ctx.rotate(p.rot);
          ctx.drawImage(sprite, -p.s / 2, -p.s / 2, p.s, p.s);
          ctx.restore();
        });
      }
    };
  }

  function initSmoke() {
    // Mouvement réduit : la fumée ne bouge plus, mais l'atmosphère reste —
    // on ne prive personne de l'identité visuelle du site.
    var h = $('#smoke-hero');
    if (h) {
      var sh = Smoke(h, {
        count: 20, min: 320, max: 760, rise: 0.55, drift: 0.4,
        peak: 0.5, alphaMin: 0.35, alphaMax: 0.85
      });
      if (reduced) { sh.still(); addEventListener('resize', sh.still, { passive: true }); }
      else sh.start(false);
    }

    var o = $('#smoke-obs');
    if (o) {
      // nappe rouge dense qui monte au moment où la vitrine entre à l'écran
      var so = Smoke(o, {
        count: 34, min: 300, max: 780, rise: 1.5, drift: 0.7,
        peak: 0.62, alphaMin: 0.5, alphaMax: 1
      });
      var sec = o.closest('.obs') || o.parentElement;
      if (reduced) { so.still(); addEventListener('resize', so.still, { passive: true }); }
      else if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (en) {
          if (en[0].isIntersecting) { so.start(true); io.disconnect(); }
        }, { threshold: 0.12 });
        io.observe(sec);
      } else so.start(true);
    }

    $$('.smoke-band').forEach(function (c) {
      var s = Smoke(c, { count: 14, min: 300, max: 700, rise: 0.8, drift: 0.4, peak: 0.45, alphaMin: 0.3, alphaMax: 0.8 });
      if (reduced) { s.still(); addEventListener('resize', s.still, { passive: true }); return; }
      if ('IntersectionObserver' in window) {
        var io2 = new IntersectionObserver(function (en) {
          if (en[0].isIntersecting) { s.start(true); io2.disconnect(); }
        }, { threshold: 0.15 });
        io2.observe(c.parentElement || c);
      } else s.start(true);
    });
  }

  /* ======================================================================
     3. TRANSITION DE PAGE + BARRE DE PROGRESSION
     ====================================================================== */
  function initChrome() {
    var bar = document.createElement('div');
    bar.id = 'progress';
    document.body.appendChild(bar);
    // une seule mise à jour par image (lire scrollHeight à chaque évènement force un recalcul de mise en page)
    var barTick = false;
    addEventListener('scroll', function () {
      if (barTick) return; barTick = true;
      requestAnimationFrame(function () {
        barTick = false;
        var max = document.documentElement.scrollHeight - innerHeight;
        bar.style.transform = 'scaleX(' + (max > 0 ? scrollY / max : 0).toFixed(4) + ')';
      });
    }, { passive: true });

    if (reduced) return;
    // le voile est déjà dans la page (layout) et le script en ligne l'a lancé dès le premier affichage
    var wipe = document.getElementById('wipe');
    if (!wipe) {
      wipe = document.createElement('div');
      wipe.id = 'wipe';
      wipe.innerHTML = '<img src="' + (window.SK_ASSETS || '') + 'img-logo.svg" alt="">';
      document.body.appendChild(wipe);
    }

    // entrée : le voile se retire
    if (Store.get('stickit_seen')) {
      wipe.classList.add('in');
      setTimeout(function () { wipe.classList.remove('in'); }, 520);
    }

    document.addEventListener('click', function (ev) {
      if (!ev.target.closest) return;
      // un bouton posé dans un lien (aperçu rapide, etc.) ne déclenche pas la navigation
      if (ev.target.closest('button,[data-qv],[data-open-cart]')) return;
      var a = ev.target.closest('a');
      if (!a) return;
      var href = a.getAttribute('href') || '';
      if (!href || href.charAt(0) === '#' || a.target === '_blank' ||
          /^(mailto:|tel:|https?:)/.test(href) || a.hasAttribute('data-open-cart') ||
          ev.metaKey || ev.ctrlKey || ev.shiftKey) return;
      ev.preventDefault();
      Store.set('stickit_seen', '1');
      wipe.classList.remove('in');
      wipe.classList.add('out');
      setTimeout(function () { location.href = href; }, 400);
    });

    // retour arrière : le navigateur restaure la page telle qu'elle était au départ (cache « bfcache »),
    // voile de transition encore fermé → écran de chargement bloqué (surtout sur téléphone). On le rouvre.
    addEventListener('pageshow', function (ev) {
      if (!ev.persisted) return;
      wipe.classList.remove('out');
      wipe.classList.remove('in');
      document.body.classList.add('loaded');
      var pre = $('#preloader'); if (pre) pre.remove();
    });
  }

  /* ======================================================================
     4. PRÉCHARGEMENT
     ====================================================================== */
  function initPreloader() {
    var pre = $('#preloader');
    if (!pre || window.SK_PRE) return;   // déjà piloté par le script en ligne du layout
    // seulement à la toute première visite : ensuite c'est la transition qui prend le relais
    if (Store.get('stickit_seen')) { pre.remove(); document.body.classList.add('loaded'); return; }

    var bar = $('.pre-bar i', pre), num = $('.pre-num', pre), p = 0;
    var tick = setInterval(function () {
      p += Math.random() * 16 + 7;
      if (p >= 100) { p = 100; clearInterval(tick); }
      if (bar) bar.style.width = p + '%';
      if (num) num.textContent = String(Math.round(p)).padStart(3, '0');
    }, 120);
    function close() {
      clearInterval(tick);
      if (bar) bar.style.width = '100%';
      if (num) num.textContent = '100';
      Store.set('stickit_seen', '1');
      setTimeout(function () { pre.classList.add('done'); document.body.classList.add('loaded'); }, 320);
    }
    if (document.readyState === 'complete') setTimeout(close, 600);
    else addEventListener('load', function () { setTimeout(close, 460); });
    setTimeout(close, 4000);
  }

  /* ======================================================================
     5. RÉVÉLATIONS + DÉCOUPE DE TITRES
     ====================================================================== */
  function initSplit() {
    $$('.split').forEach(function (el) {
      if (el.dataset.split) return;
      el.dataset.split = '1';
      var words = (el.textContent || '').trim().split(/\s+/);
      var total = words.join('').length;
      var step = total > 24 ? Math.max(10, Math.round(560 / total)) : 30;
      var html = '', idx = 0;
      words.forEach(function (w, wi) {
        html += '<span class="wd">';
        for (var i = 0; i < w.length; i++) {
          var ch = w[i];
          ch = ch === '&' ? '&amp;' : ch === '<' ? '&lt;' : ch === '>' ? '&gt;' : ch;
          html += '<span class="ch" style="transition-delay:' + (idx * step) + 'ms">' + ch + '</span>';
          idx++;
        }
        html += '</span>';
        if (wi < words.length - 1) html += '<span class="sp"></span>';
      });
      el.innerHTML = html;
    });
  }

  function initReveal() {
    // volet sur toutes les images de contenu
    $$('.ccard,.band-bg,.obs-banner,.case .ph,.hero-visual').forEach(function (el) {
      el.classList.add('clip-img');
    });

    var els = $$('.reveal,.reveal-x,.reveal-s,.split,.rule,.cutline,.clip,.clip-img,.obs');
    if (!('IntersectionObserver' in window) || reduced) {
      els.forEach(function (e) { e.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (ent) {
      ent.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target, d = parseFloat(el.getAttribute('data-delay') || 0);
        if (d) setTimeout(function () { el.classList.add('in'); }, d);
        else el.classList.add('in');
        io.unobserve(el);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (e) { io.observe(e); });

    $$('[data-stagger]').forEach(function (par) {
      var step = parseInt(par.getAttribute('data-stagger'), 10) || 80;
      $$(':scope > *', par).forEach(function (ch, i) {
        ch.style.transitionDelay = (i * step) + 'ms';
      });
    });
  }

  /* ======================================================================
     6. COMPTEURS
     ====================================================================== */
  function initCounters() {
    var els = $$('[data-count-up]');
    if (!els.length) return;
    function run(el) {
      var raw = el.textContent.trim();
      var m = raw.match(/^([^\d]*)([\d.,]+)(.*)$/);
      if (!m) return;
      var pre = m[1], target = parseFloat(m[2].replace(',', '.')), suf = m[3];
      var dec = (m[2].indexOf('.') > -1 || m[2].indexOf(',') > -1) ? 1 : 0;
      var t0 = performance.now(), dur = 1400;
      el.classList.add('count-up');
      (function step(now) {
        var k = clamp((now - t0) / dur, 0, 1);
        var eased = 1 - Math.pow(1 - k, 3);
        el.textContent = pre + (target * eased).toFixed(dec) + suf;
        if (k < 1) requestAnimationFrame(step);
        else el.textContent = raw;
      })(t0);
    }
    if (!('IntersectionObserver' in window) || reduced) return;
    var io = new IntersectionObserver(function (ent) {
      ent.forEach(function (en) { if (en.isIntersecting) { run(en.target); io.unobserve(en.target); } });
    }, { threshold: 0.6 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ======================================================================
     7. INCLINAISON 3D DES CARTES
     ====================================================================== */
  function initTilt() {
    if (!fine || reduced) return;
    $$('.pcard,.ccard,.obs-item').forEach(function (card) {
      if (card.classList.contains('pcard') && !$('.glare', card)) {
        var g = document.createElement('span'); g.className = 'glare';
        card.appendChild(g);
      }
      var frozen = false;
      card.addEventListener('mousemove', function (ev) {
        if (frozen) return;
        var r = card.getBoundingClientRect();
        var px = (ev.clientX - r.left) / r.width, py = (ev.clientY - r.top) / r.height;
        var rx = (0.5 - py) * 9, ry = (px - 0.5) * 9;
        card.style.transform = 'perspective(1000px) rotateX(' + rx.toFixed(2) + 'deg) rotateY(' +
          ry.toFixed(2) + 'deg) translateY(-5px) scale(1.012)';
        card.style.setProperty('--gx', (px * 100).toFixed(1) + '%');
        card.style.setProperty('--gy', (py * 100).toFixed(1) + '%');
      });
      card.addEventListener('mouseleave', function () { card.style.transform = ''; frozen = false; });

      // au survol d'un bouton posé sur la carte, on fige l'inclinaison :
      // sinon la cible bouge sous le curseur au moment du clic
      var btn = $('.qv', card);
      if (btn) {
        btn.addEventListener('mouseenter', function () {
          frozen = true;
          card.style.transform = 'perspective(1000px) translateY(-5px) scale(1.012)';
        });
        btn.addEventListener('mouseleave', function () { frozen = false; });
      }
    });
  }

  /* ======================================================================
     8. BOUTONS MAGNÉTIQUES
     ====================================================================== */
  function initMagnetic() {
    if (!fine || reduced) return;
    $$('[data-magnetic]').forEach(function (el) {
      var raf = null, tx = 0, ty = 0, cx = 0, cy = 0;
      function run() {
        cx = lerp(cx, tx, 0.2); cy = lerp(cy, ty, 0.2);
        el.style.transform = 'translate3d(' + cx.toFixed(2) + 'px,' + cy.toFixed(2) + 'px,0)';
        if (Math.abs(cx - tx) > 0.1 || Math.abs(cy - ty) > 0.1) raf = requestAnimationFrame(run);
        else { el.style.transform = 'translate3d(' + tx + 'px,' + ty + 'px,0)'; raf = null; }
      }
      el.addEventListener('mousemove', function (ev) {
        var r = el.getBoundingClientRect();
        tx = (ev.clientX - r.left - r.width / 2) * 0.3;
        ty = (ev.clientY - r.top - r.height / 2) * 0.38;
        if (!raf) raf = requestAnimationFrame(run);
      });
      el.addEventListener('mouseleave', function () { tx = ty = 0; if (!raf) raf = requestAnimationFrame(run); });
    });
  }

  /* ======================================================================
     9. BANDE DÉFILANTE RÉACTIVE À LA VITESSE DE DÉFILEMENT
     ====================================================================== */
  function initMarquee() {
    var tracks = $$('.marquee .track');
    if (!tracks.length || reduced) return;
    var last = scrollY, vel = 0, on = false, shown = '';
    // la boucle ne tourne que pendant le défilement et s'arrête une fois l'inclinaison retombée
    function loop() {
      vel *= 0.92;
      if (Math.abs(vel) < 0.02) vel = 0;
      var sk = 'skewX(' + (vel * 0.55).toFixed(2) + 'deg)';
      if (sk !== shown) { shown = sk; tracks.forEach(function (t) { t.style.transform = sk; }); }
      if (vel) requestAnimationFrame(loop); else on = false;
    }
    addEventListener('scroll', function () {
      vel = clamp((scrollY - last) * 0.35, -16, 16);
      last = scrollY;
      if (!on && vel) { on = true; requestAnimationFrame(loop); }
    }, { passive: true });
  }

  /* ======================================================================
     10. TEXTE BROUILLÉ AU SURVOL
     ====================================================================== */
  function initScramble() {
    if (!fine || reduced) return;
    var CH = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789/\\#@$%&*';
    $$('.nav-links a,.more,.chip').forEach(function (el) {
      var orig = el.textContent, busy = false;
      el.addEventListener('mouseenter', function () {
        if (busy) return;
        busy = true;
        var i = 0;
        var id = setInterval(function () {
          el.textContent = orig.split('').map(function (c, k) {
            if (k < i || c === ' ') return c;
            return CH[Math.floor(Math.random() * CH.length)];
          }).join('');
          i += 1 / 2;
          if (i >= orig.length) { clearInterval(id); el.textContent = orig; busy = false; }
        }, 26);
      });
    });
  }

  /* ======================================================================
     11. PARALLAXE
     ====================================================================== */
  function initParallax() {
    if (reduced) return;
    var els = $$('[data-parallax]');
    if (!els.length) return;
    var ticking = false;
    function run() {
      var vh = innerHeight;
      els.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        var sp = parseFloat(el.getAttribute('data-parallax')) || 0.14;
        el.style.transform = 'translate3d(0,' + ((r.top + r.height / 2 - vh / 2) * sp).toFixed(1) + 'px,0)';
      });
      ticking = false;
    }
    addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(run); } }, { passive: true });
    run();
  }

  /* ======================================================================
     11b. VIDÉO DE FOND — n'autoplay jamais si prefers-reduced-motion,
     la vidéo reste alors sur son poster (image de repli). Ralentie : la
     rotation du casque filmée en vitesse normale tourne trop vite pour un
     fond d'ambiance, on la joue au ralenti.
     ====================================================================== */
  // vitesse normale (skin.js la remettait à 1 aussitôt : le va-et-vient 0,4 → 1 donnait un à-coup au démarrage)
  var BG_VIDEO_RATE = 1;
  function initBgVideo() {
    $$('video[data-bg-video]').forEach(function (v) {
      if (reduced) { v.pause(); v.removeAttribute('autoplay'); return; }
      v.playbackRate = BG_VIDEO_RATE;
      v.addEventListener('loadedmetadata', function () { v.playbackRate = BG_VIDEO_RATE; });
      if (v.hasAttribute('data-sk-lazyplay')) return;   // lancée par skin.js quand elle arrive à l'écran
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    });
  }

  /* ======================================================================
     12. EN-TÊTE + MENU MOBILE
     ====================================================================== */
  function initHeader() {
    // Le bandeau et le header forment une seule unité collée (.topbar) : on ne
    // masque jamais l'en-tête au scroll — il se resserre, c'est tout.
    var bar = $('.topbar');
    if (bar) {
      var sync = function () { bar.classList.toggle('scrolled', scrollY > 40); };
      addEventListener('scroll', sync, { passive: true });
      sync();
    }
    var b = $('.burger');
    if (b) b.addEventListener('click', function () { document.body.classList.toggle('menu-open'); });
  }

  /* ======================================================================
     13. PANIER
     ====================================================================== */
  var Cart = {
    key: 'stickit_cart_v1',
    read: function () { try { return JSON.parse(Store.get(this.key) || '[]'); } catch (e) { return []; } },
    write: function (items) { Store.set(this.key, JSON.stringify(items)); this.render(); },
    add: function (item) {
      var items = this.read(), k = item.id + '|' + item.variant, found = null;
      items.forEach(function (i) { if (i.id + '|' + i.variant === k) found = i; });
      if (found) found.qty += item.qty; else items.push(item);
      this.write(items);
      toast('Ajouté au panier');
      document.body.classList.add('cart-open');
    },
    remove: function (i) { var it = this.read(); it.splice(i, 1); this.write(it); },
    total: function () { return this.read().reduce(function (s, i) { return s + i.price * i.qty; }, 0); },
    count: function () { return this.read().reduce(function (s, i) { return s + i.qty; }, 0); },
    render: function () {
      var n = this.count();
      $$('.bag .count').forEach(function (e) { e.textContent = '(' + n + ')'; });
      var body = $('.drawer-body'), foot = $('.drawer-f');
      if (!body) return;
      var items = this.read();
      if (!items.length) {
        body.innerHTML = '<div class="drawer-empty">Ton panier est vide.<br>Il attend son premier sticker.</div>';
        if (foot) foot.style.display = 'none';
        return;
      }
      if (foot) foot.style.display = '';
      body.innerHTML = items.map(function (i, idx) {
        return '<div class="citem"><div class="ph"><img src="' + i.img + '" alt="" loading="lazy"></div>' +
          '<div><h4>' + esc(i.name) + '</h4>' +
          (i.variant ? '<div class="v">' + esc(i.variant) + '</div>' : '') +
          '<div class="p">' + fmt(i.price) + ' CHF × ' + i.qty + '</div>' +
          '<a class="rm" data-rm="' + idx + '">Retirer</a></div>' +
          '<div class="p">' + fmt(i.price * i.qty) + '</div></div>';
      }).join('') + upsellHtml(items);
      var t = $('.drawer-f .tot b'); if (t) t.textContent = fmt(this.total()) + ' CHF';
      var self = this;
      $$('[data-rm]', body).forEach(function (a) {
        a.addEventListener('click', function () { self.remove(parseInt(a.getAttribute('data-rm'), 10)); });
      });
    }
  };
  /* --- « Complète ta commande » : petits stickers ajoutés en un clic, sous les articles du panier ---
     Liste dans layout/theme.liquid (#sk-upsell) : produit, options fixes, couleur au choix, prix CHF (à tenir à jour
     comme les fiches produit). Un produit déjà dans le panier n'est plus proposé. */
  var UPSELL = null;
  function upsellList() {
    if (UPSELL) return UPSELL;
    try { UPSELL = JSON.parse(($('#sk-upsell') || {}).textContent || '[]'); } catch (e) { UPSELL = []; }
    // ordre tiré au hasard une fois par page : les suggestions changent d'une page à l'autre,
    // mais ne bougent pas pendant que le client regarde son panier
    for (var i = UPSELL.length - 1; i > 0; i--) { var r = Math.floor(Math.random() * (i + 1)), x = UPSELL[i]; UPSELL[i] = UPSELL[r]; UPSELL[r] = x; }
    return UPSELL;
  }
  function upsellHtml(items) {
    var inCart = {}; items.forEach(function (i) { inCart[i.id] = 1; });
    var list = upsellList().filter(function (u) { return !inCart[u.handle]; }).slice(0, 2);
    if (!list.length) return '';
    return '<div class="sk-upsell"><p class="sk-upsell-t">Complète ta commande</p>' + list.map(function (u) {
      return '<div class="sk-up" data-up="' + esc(u.handle) + '"><img src="' + esc(u.img) + '" alt="" width="56" height="56" loading="lazy">' +
        '<div class="sk-up-b"><b>' + esc(u.label) + '</b><span class="sk-up-p">' + fmt(u.price) + ' CHF</span>' +
        '<div class="sk-up-c" role="group" aria-label="' + esc(u.choice) + '">' + u.values.map(function (v, k) {
          return '<button type="button" data-up-v="' + esc(v) + '" aria-pressed="' + (k ? 'false' : 'true') + '"' + (k ? '' : ' class="on"') + '>' + esc(v) + '</button>';
        }).join('') + '</div></div>' +
        '<button type="button" class="sk-up-add" data-up-add>Ajouter</button></div>';
    }).join('') + '</div>';
  }
  document.addEventListener('click', function (ev) {
    var t = ev.target.closest && ev.target.closest('[data-up-v],[data-up-add]');
    if (!t) return;
    var box = t.closest('[data-up]'), u = upsellList().filter(function (x) { return x.handle === box.getAttribute('data-up'); })[0];
    if (!u) return;
    if (t.hasAttribute('data-up-v')) {
      $$('[data-up-v]', box).forEach(function (b) { var on = b === t; b.classList.toggle('on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      return;
    }
    var pick = $('[data-up-v].on', box), v = pick ? pick.getAttribute('data-up-v') : u.values[0];
    Cart.add({ id: u.handle, name: u.name, variant: u.fixed.map(function (f) { return f[0] + ' : ' + f[1]; }).concat([u.choice + ' : ' + v]).join(' · '),
      price: u.price, qty: 1, img: u.img });
  });

  function fmt(n) { return (Math.round(n * 100) / 100).toFixed(2); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }
  var toastEl = null, toastT = null;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'toast'; document.body.appendChild(toastEl); }
    toastEl.textContent = msg;
    toastEl.classList.add('on');
    clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.classList.remove('on'); }, 2400);
  }
  function initCart() {
    Cart.render();
    $$('[data-open-cart]').forEach(function (b) {
      b.addEventListener('click', function (ev) { ev.preventDefault(); document.body.classList.add('cart-open'); });
    });
    $$('[data-close-cart]').forEach(function (b) {
      b.addEventListener('click', function () { document.body.classList.remove('cart-open'); });
    });
    addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape') document.body.classList.remove('cart-open', 'menu-open');
    });
  }

  /* Supplément additif des options choisies (data.options[].surcharge = { valeur: CHF }),
     ajouté après la remise éventuelle. */
  function surchargeOf(p, sel) {
    var s = 0;
    (p.options || []).forEach(function (o) {
      var v = sel[o.name];
      if (v != null && o.surcharge && o.surcharge[v]) s += surchargeFor(o, v, sel);
    });
    return Math.round(s * 100) / 100;
  }
  // supplément d'une valeur ; avec surchargeBy, il dépend d'une autre option (ex. couleur spéciale selon la hauteur)
  function surchargeFor(o, v, sel) {
    var by = o.surchargeBy, t = by && by.values[sel[by.option]];
    return t != null ? t : o.surcharge[v];
  }
  // étiquettes « +X » des valeurs à supplément et note du groupe, une fois l'option de référence choisie
  function syncSurcharge(p, sel, root) {
    (p.options || []).forEach(function (o) {
      var by = o.surchargeBy, t = by && by.values[sel[by.option]];
      if (t == null) return;
      var lbl = '+' + String(+(+t).toFixed(2));
      $$('[data-opt]', root).forEach(function (b) {
        if (b.getAttribute('data-opt') === o.name && o.surcharge[b.getAttribute('data-val')]) b.setAttribute('data-sk-plus', lbl);
      });
      var n = $('.sw-group-special span', root); if (n) n.textContent = lbl + ' CHF';
    });
  }
  function finalPrice(p, cat, sel) {
    return Math.round(((p.discount ? cat * (1 - p.discount) : cat) + surchargeOf(p, sel)) * 100) / 100;
  }
  // prix catalogue le plus bas encore possible : une option tarifée non choisie compte pour sa valeur la moins chère
  function priceFrom(p, sel) {
    var c = p.base;
    (p.options || []).forEach(function (o) {
      if (!o.prices) return;
      var v = sel[o.name];
      if (v != null && o.prices[v] != null) { c = o.prices[v]; return; }
      var vals = (o.values || []).map(function (x) { return o.prices[x]; }).filter(function (x) { return x != null; });
      if (vals.length) c = Math.min.apply(null, vals);
    });
    return c;
  }

  /* ======================================================================
     14. FICHE PRODUIT
     ====================================================================== */
  function initPDP() {
    var pdp = $('[data-pdp]');
    if (!pdp) return;
    var data = {};
    try { data = JSON.parse($('#product-data').textContent); } catch (e) { return; }

    var mains = $$('.gal-main img'), thumbs = $$('.gal-thumbs button');
    var current = 0;
    function show(i) {
      current = i;
      mains.forEach(function (m, k) { m.classList.toggle('on', k === i); });
      thumbs.forEach(function (t, k) { t.classList.toggle('on', k === i); });
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
    show(0);

    /* --- agrandissement plein écran --------------------------------------- */
    var lb = $('#lightbox');
    if (lb) {
      var lbImg = $('img', lb), lbCount = $('.lb-count', lb);
      var pics = data.images || [];
      function openLb(i) {
        if (!pics.length) return;
        current = (i + pics.length) % pics.length;
        lbImg.src = pics[current];
        lbImg.alt = data.name + ' — vue ' + (current + 1);
        lbCount.textContent = (current + 1) + ' / ' + pics.length;
        lb.classList.add('on');
        lb.setAttribute('aria-hidden', 'false');
      }
      function closeLb() { lb.classList.remove('on'); lb.setAttribute('aria-hidden', 'true'); }
      var gm = $('.gal-main[data-zoom]');
      if (gm) gm.addEventListener('click', function () { openLb(current); });
      $('.lb-close', lb).addEventListener('click', closeLb);
      $('.lb-prev', lb).addEventListener('click', function (ev) { ev.stopPropagation(); openLb(current - 1); });
      $('.lb-next', lb).addEventListener('click', function (ev) { ev.stopPropagation(); openLb(current + 1); });
      lb.addEventListener('click', function (ev) { if (ev.target === lb || ev.target === lbImg) closeLb(); });
      addEventListener('keydown', function (ev) {
        if (!lb.classList.contains('on')) return;
        if (ev.key === 'Escape') closeLb();
        if (ev.key === 'ArrowLeft') openLb(current - 1);
        if (ev.key === 'ArrowRight') openLb(current + 1);
      });
    }

    var sel = {};
    function priceNow() {
      var p = data.base;
      (data.options || []).forEach(function (o) {
        var v = sel[o.name];
        if (v != null && o.prices && o.prices[v] != null) p = o.prices[v];
      });
      return p;
    }
    // champs de texte obligatoires (pseudo, numéro, texte à découper) encore vides
    function emptyFields() { return $$('[data-custom][required]').filter(function (f) { return !f.value.trim(); }); }
    function refresh() {
      var optMissing = (data.options || []).some(function (o) { return !sel[o.name]; });
      var missing = optMissing || emptyFields().length > 0;
      // tant qu'il manque une option, on affiche le prix de départ : « dès X CHF »
      var cat = optMissing ? priceFrom(data, sel) : priceNow(), shown = finalPrice(data, cat, sel);
      var label = (optMissing ? 'dès ' : '') + fmt(shown) + ' CHF';
      var pb = $('.pdp-price b'); if (pb) pb.textContent = label;
      var ps = $('.pdp-price s'); if (ps) ps.textContent = data.discount ? fmt(cat + surchargeOf(data, sel)) + ' CHF' : '';
      var bb = $('[data-buybar-price]'); if (bb) bb.textContent = label;
      syncSurcharge(data, sel, document);
      $$('.opt .lab em').forEach(function (el) { el.textContent = sel[el.getAttribute('data-for')] || ''; });
      [$('[data-add]'), $('[data-add-mobile]')].forEach(function (btn) {
        if (!btn) return;
        btn.disabled = missing;
        var sp = btn.querySelector('span');
        if (sp) sp.textContent = missing
          ? (btn.hasAttribute('data-add-mobile') ? 'Choisis' : 'Choisis tes options')
          : (btn.hasAttribute('data-add-mobile') ? 'Ajouter' : 'Ajouter au panier');
      });
      syncNeed();
    }

    /* --- consigne au-dessus du panier : dit pourquoi le bouton est grisé --- */
    // Sans elle, des clients prenaient « Choisis tes options » grisé pour une panne ou un produit indisponible.
    // Chaque nom d'option est un lien vers son choix ; textes séparés pour la traduction (i18n.js).
    var need = null, needKey = null;
    function syncNeed() {
      var miss = (data.options || []).filter(function (o) { return !sel[o.name]; }).map(function (o) { return o.name; });
      var fields = emptyFields();
      var key = miss.concat(fields.map(function (f) { return '#' + f.getAttribute('data-custom'); })).join('|');
      if (key === needKey) return;
      needKey = key;
      if (!need) {
        var cta = $('.pdp-cta');
        if (!cta) return;
        need = document.createElement('div');
        need.className = 'pdp-need';
        need.setAttribute('role', 'status');
        need.setAttribute('aria-live', 'polite');
        var anchor = $('.pdp-info > .qty') || cta;
        anchor.parentNode.insertBefore(need, anchor);
        need.addEventListener('click', function (ev) {
          var go = ev.target.closest('[data-need]');
          if (!go) return;
          if (go.hasAttribute('data-need-field')) {   // champ de texte : on y amène le curseur
            var inp = $$('[data-custom]').filter(function (x) { return x.getAttribute('data-custom') === go.getAttribute('data-need-field'); })[0];
            if (inp) { inp.scrollIntoView({ behavior: 'smooth', block: 'center' }); inp.focus({ preventScroll: true }); }
            return;
          }
          var b = $$('[data-opt]').filter(function (x) { return x.getAttribute('data-opt') === go.getAttribute('data-need'); })[0];
          var opt = b && b.closest('.opt');
          if (!opt) return;
          opt.classList.remove('sk-need'); void opt.offsetWidth; opt.classList.add('sk-need');
          opt.scrollIntoView({ behavior: 'smooth', block: 'center' });
          b.focus({ preventScroll: true });
        });
      }
      need.hidden = !miss.length && !fields.length;
      need.innerHTML = '';
      if (!miss.length && !fields.length) return;
      var t = document.createElement('span');
      t.className = 'pdp-need-t';
      t.textContent = 'Pour activer le bouton, choisis :';
      need.appendChild(t);
      miss.forEach(function (name) {
        var g = document.createElement('button');
        g.type = 'button';
        g.setAttribute('data-need', name);
        g.textContent = name;
        need.appendChild(g);
      });
      fields.forEach(function (f) {
        var g = document.createElement('button');
        g.type = 'button';
        g.setAttribute('data-need', '');
        g.setAttribute('data-need-field', f.getAttribute('data-custom'));
        g.textContent = f.getAttribute('data-custom');
        need.appendChild(g);
      });
    }
    $$('[data-custom]').forEach(function (f) { f.addEventListener('input', refresh); });
    $$('[data-opt]').forEach(function (b) {
      b.addEventListener('click', function () {
        var name = b.getAttribute('data-opt');
        sel[name] = b.getAttribute('data-val');
        $$('[data-opt]').forEach(function (o) {
          if (o.getAttribute('data-opt') === name) o.classList.remove('on');
        });
        b.classList.add('on');
        // l'aperçu du texte reprend la couleur sélectionnée
        var col = b.getAttribute('data-color');
        if (col) {
          var prev = $('.cust-preview');
          if (prev) prev.style.setProperty('--preview-color', col.indexOf('gradient') > -1 ? '#DFDFE6' : col);
        }
        refresh();
      });
    });

    /* --- aperçu en direct du texte personnalisé --------------------------- */
    $$('[data-preview]').forEach(function (inp) {
      var out = $('[data-preview-out]', inp.closest('.field'));
      if (!out) return;
      inp.addEventListener('input', function () {
        out.textContent = inp.value.trim() || 'TON TEXTE';
      });
    });

    /* --- barre d'achat mobile --------------------------------------------- */
    // visible dès qu'on a quitté le haut de page et que le bouton principal
    // n'est plus à l'écran — qu'il soit au-dessus ou en dessous
    var bar = $('.buybar'), cta = $('.pdp-cta');
    if (bar && cta) {
      var syncBar = function () {
        var r = cta.getBoundingClientRect();
        var visible = r.bottom > 60 && r.top < innerHeight - 40;
        bar.classList.toggle('on', scrollY > 380 && !visible);
      };
      addEventListener('scroll', syncBar, { passive: true });
      addEventListener('resize', syncBar);
      syncBar();
    }
    var addM = $('[data-add-mobile]');
    if (addM) addM.addEventListener('click', function () {
      var a = $('[data-add]'); if (a) a.click();
    });
    (data.options || []).forEach(function (o) {
      if (o.values && o.values.length === 1) sel[o.name] = o.values[0];
    });
    $$('[data-opt]').forEach(function (b) {
      if (sel[b.getAttribute('data-opt')] === b.getAttribute('data-val')) b.classList.add('on');
    });
    refresh();

    /* --- lien partageable : les options choisies vont dans l'adresse ------- */
    // #couleur-disponible=noir&taille=4cm ; à l'ouverture, ce lien — ou le ?variant=ID de Google Shopping /
    // des liens Shopify — reclique les mêmes boutons (prix, photo et panier suivent comme au clic).
    var slug = function (v) { return String(v || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); };
    var fromLink = false;
    function pick(name, val) {
      var same = function (a, b) { return slug(a).replace(/-/g, '') === slug(b).replace(/-/g, ''); };
      var group = $$('[data-opt]').filter(function (b) { return same(b.getAttribute('data-opt'), name); });
      if (!group.length) group = $$('[data-opt]');
      var b = group.filter(function (x) { return same(x.getAttribute('data-val'), val); })[0];
      if (b && !b.classList.contains('on')) b.click();
    }
    function writeLink() {
      if (fromLink) return;
      var parts = [];
      (data.options || []).forEach(function (o) {
        if (sel[o.name] && !(o.values && o.values.length === 1)) parts.push(slug(o.name) + '=' + slug(sel[o.name]));
      });
      var q = location.search.replace(/([?&])variant=[^&]*&?/, '$1').replace(/[?&]$/, '');
      try { history.replaceState(history.state, '', location.pathname + q + (parts.length ? '#' + parts.join('&') : '')); } catch (e) {}
    }
    $$('[data-opt]').forEach(function (b) { b.addEventListener('click', writeLink); });
    setTimeout(function () {
      var h = location.hash.slice(1), vid = (/[?&]variant=(\d+)/.exec(location.search) || [])[1];
      if (h && h.indexOf('=') > 0) {
        fromLink = true;
        h.split('&').forEach(function (kv) { var p = kv.split('='); try { if (p[1]) pick(decodeURIComponent(p[0]), decodeURIComponent(p[1])); } catch (e) {} });
        fromLink = false;
      } else if (vid && window.fetch) {
        fetch('/products/' + encodeURIComponent(data.handle) + '.js').then(function (r) { return r.json(); }).then(function (p) {
          var v = (p.variants || []).filter(function (x) { return String(x.id) === vid; })[0];
          if (!v) return;
          fromLink = true;
          (p.options || []).forEach(function (o, i) { pick(o.name || o, v['option' + (i + 1)]); });
          fromLink = false;
        }).catch(function () {});
      }
    }, 0);

    var qi = $('.qty input');
    $$('.qty button').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = (parseInt(qi.value, 10) || 1) + (b.getAttribute('data-q') === '+' ? 1 : -1);
        qi.value = clamp(v, 1, 99);
      });
    });

    var add = $('[data-add]');
    if (add) add.addEventListener('click', function () {
      if (add.disabled || emptyFields().length) return;
      var parts = [];
      (data.options || []).forEach(function (o) { if (sel[o.name]) parts.push(o.name + ' : ' + sel[o.name]); });
      $$('[data-custom]').forEach(function (f) {
        if (f.value) parts.push(f.getAttribute('data-custom') + ' : ' + f.value);
      });
      var cat = priceNow();
      Cart.add({
        id: data.handle, name: data.name, variant: parts.join(' · '),
        price: finalPrice(data, cat, sel),
        qty: parseInt(qi ? qi.value : 1, 10) || 1, img: data.img
      });
    });
  }

  /* ======================================================================
     15. FILTRES BOUTIQUE
     ====================================================================== */
  function initShop() {
    var grid = $('[data-shop-grid]');
    if (!grid) return;
    var cards = $$('.pcard', grid);
    var countEl = $('[data-count]');
    var emptyEl = $('[data-empty]');
    var state = { cols: 'all', finish: 'all', bucket: 'all' };

    function matches(c) {
      if (state.cols !== 'all' && (c.getAttribute('data-cols') || '').split('|').indexOf(state.cols) < 0) return false;
      if (state.finish !== 'all' && (c.getAttribute('data-finish') || '').split('|').indexOf(state.finish) < 0) return false;
      if (state.bucket !== 'all' && c.getAttribute('data-bucket') !== state.bucket) return false;
      return true;
    }

    function apply(pushHash) {
      var n = 0;
      cards.forEach(function (c) {
        var ok = matches(c);
        c.classList.toggle('hidden', !ok);
        if (ok) { n++; c.style.transitionDelay = Math.min(n * 30, 400) + 'ms'; }
      });
      if (countEl) countEl.textContent = n + (n > 1 ? ' produits' : ' produit');
      if (emptyEl) emptyEl.hidden = n > 0;
      $$('.chip[data-f]').forEach(function (ch) {   // [data-f] : pas les pastilles du tri (shop.js)
        ch.classList.toggle('on', state[ch.getAttribute('data-f')] === ch.getAttribute('data-v'));
      });
      if (pushHash) {
        var parts = [];
        Object.keys(state).forEach(function (k) { if (state[k] !== 'all') parts.push(k + '=' + state[k]); });
        var h = parts.join('&');
        try { history.replaceState(null, '', h ? '#' + h : location.pathname); } catch (e) {}
      }
    }

    $$('.chip[data-f]').forEach(function (ch) {
      ch.addEventListener('click', function () {
        var f = ch.getAttribute('data-f'), v = ch.getAttribute('data-v');
        // recliquer sur un filtre actif le désactive
        state[f] = (state[f] === v && v !== 'all') ? 'all' : v;
        apply(true);
      });
    });
    var reset = $('[data-freset]');
    if (reset) reset.addEventListener('click', function (ev) {
      ev.preventDefault();
      state = { cols: 'all', finish: 'all', bucket: 'all' };
      apply(true);
    });

    // filtres partageables par l'URL
    if (location.hash.length > 1) {
      location.hash.slice(1).split('&').forEach(function (kv) {
        var p = kv.split('=');
        if (p.length === 2 && state.hasOwnProperty(p[0])) state[p[0]] = decodeURIComponent(p[1]);
      });
    }

    var sort = $('select.sort');
    if (sort) sort.addEventListener('change', function () {
      var v = sort.value, arr = cards.slice();
      arr.sort(function (a, b) {
        var pa = parseFloat(a.getAttribute('data-price')), pb = parseFloat(b.getAttribute('data-price'));
        if (v === 'asc') return pa - pb;
        if (v === 'desc') return pb - pa;
        if (v === 'az') return ($('h3', a).textContent).localeCompare($('h3', b).textContent, 'fr');
        return parseInt(a.getAttribute('data-order'), 10) - parseInt(b.getAttribute('data-order'), 10);
      });
      arr.forEach(function (c) { grid.appendChild(c); });
      if (emptyEl) grid.appendChild(emptyEl);
    });

    apply(false);
    initQuickview();
  }

  /* ======================================================================
     15 bis. APERÇU RAPIDE
     Ouvre la fiche en surcouche : galerie, options, prix recalculé, panier.
     ====================================================================== */
  function initQuickview() {
    var box = $('#quickview');
    var raw = $('#shop-data');
    if (!box || !raw) return;
    var all = [];
    try { all = JSON.parse(raw.textContent); } catch (e) { return; }
    var byHandle = {};
    all.forEach(function (p) { byHandle[p.handle] = p; });

    var elBig = $('.qv-media .big img', box), elRow = $('.qv-media .row', box);
    var elTitle = $('.qv-body h3', box), elB = $('.qv-price b', box), elS = $('.qv-price s', box);
    var elLede = $('.qv-body .pdp-lede', box), elOpts = $('.qv-opts', box), elLink = $('.qv-link', box);
    var cur = null, sel = {};

    function priceNow() {
      var p = cur.base;
      (cur.options || []).forEach(function (o) {
        var v = sel[o.name];
        if (v != null && o.prices && o.prices[v] != null) p = o.prices[v];
      });
      return p;
    }
    function refresh() {
      var missing = (cur.options || []).some(function (o) { return !sel[o.name]; });
      var cat = missing ? priceFrom(cur, sel) : priceNow(), shown = finalPrice(cur, cat, sel);
      elB.textContent = (missing ? 'dès ' : '') + fmt(shown) + ' CHF';
      elS.textContent = cur.discount ? fmt(cat + surchargeOf(cur, sel)) + ' CHF' : '';
      syncSurcharge(cur, sel, box);
      $$('.qv-opts .lab em', box).forEach(function (el) { el.textContent = sel[el.getAttribute('data-for')] || ''; });
      var btn = $('[data-qv-add]', box);
      if (cur.custom && cur.custom.length) {   // texte à saisir (pseudo, numéro…) : uniquement sur la fiche complète
        btn.disabled = false;
        btn.querySelector('span').textContent = 'Personnaliser sur la fiche';
        return;
      }
      btn.disabled = missing;
      btn.querySelector('span').textContent = missing ? 'Choisis tes options' : 'Ajouter au panier';
    }

    function open(handle) {
      cur = byHandle[handle];
      if (!cur) return;
      sel = {};
      elTitle.textContent = cur.name;
      elLede.textContent = cur.lede;
      elLink.href = cur.url;
      elBig.src = cur.images[0];
      elBig.alt = cur.name;
      elRow.innerHTML = cur.images.map(function (u, i) {
        return '<button class="' + (i ? '' : 'on') + '" data-i="' + i + '"><img src="' + u + '" alt=""></button>';
      }).join('');
      $$('button', elRow).forEach(function (b) {
        b.addEventListener('click', function () {
          elBig.src = cur.images[parseInt(b.getAttribute('data-i'), 10)];
          $$('button', elRow).forEach(function (x) { x.classList.remove('on'); });
          b.classList.add('on');
        });
      });

      elOpts.innerHTML = (cur.options || []).map(function (o) {
        var inner;
        if (o.kind === 'color') {
          var sw = function (vals) {
            return vals.map(function (v) {
              return '<button data-qopt="' + esc(o.name) + '" data-val="' + esc(v) + '" title="' + esc(v) +
                '" style="background:' + (o.colors[v] || '#666') + '"></button>';
            }).join('');
          };
          var special = o.special || [];
          if (special.length) {
            inner = '<p class="sw-group">Couleurs normales</p><div class="swatches">' +
              sw(o.values.filter(function (v) { return special.indexOf(v) < 0; })) + '</div>' +
              '<p class="sw-group sw-group-special">Couleurs spéciales' + (o.specialNote ? ' <span>' + esc(o.specialNote) + '</span>' : '') + '</p>' +
              '<div class="swatches swatches-special">' + sw(o.values.filter(function (v) { return special.indexOf(v) > -1; })) + '</div>';
          } else inner = '<div class="swatches">' + sw(o.values) + '</div>';
        } else {
          inner = '<div class="sizes">' + o.values.map(function (v) {
            return '<button data-qopt="' + esc(o.name) + '" data-val="' + esc(v) + '">' + esc(v) + '</button>';
          }).join('') + '</div>';
        }
        return '<div class="opt"><div class="lab"><span>' + esc(o.name) +
          '</span><em data-for="' + esc(o.name) + '"></em></div>' + inner + '</div>';
      }).join('');

      if (cur.custom && cur.custom.length) {
        elOpts.innerHTML += '<p class="help" style="color:var(--grey);font-size:13px;margin-top:16px">' +
          'Ce modèle se personnalise (' + cur.custom.map(esc).join(', ') +
          ') — le champ est sur la fiche complète.</p>';
      }

      $$('[data-qopt]', box).forEach(function (b) {
        b.addEventListener('click', function () {
          var name = b.getAttribute('data-qopt');
          sel[name] = b.getAttribute('data-val');
          $$('[data-qopt]', box).forEach(function (o) {
            if (o.getAttribute('data-qopt') === name) o.classList.remove('on');
          });
          b.classList.add('on');
          refresh();
        });
      });
      (cur.options || []).forEach(function (o) {
        if (o.values && o.values.length === 1) sel[o.name] = o.values[0];
      });
      refresh();
      box.classList.add('on');
      box.setAttribute('aria-hidden', 'false');
    }
    function close() { box.classList.remove('on'); box.setAttribute('aria-hidden', 'true'); }

    document.addEventListener('click', function (ev) {
      var b = ev.target.closest && ev.target.closest('[data-qv]');
      if (!b) return;
      ev.preventDefault(); ev.stopPropagation();
      open(b.getAttribute('data-qv'));
    });
    $('.qv-close', box).addEventListener('click', close);
    box.addEventListener('click', function (ev) { if (ev.target === box) close(); });
    addEventListener('keydown', function (ev) { if (ev.key === 'Escape') close(); });

    $('[data-qv-add]', box).addEventListener('click', function () {
      if (cur.custom && cur.custom.length) { location.href = cur.url; return; }
      var parts = [];
      (cur.options || []).forEach(function (o) { if (sel[o.name]) parts.push(o.name + ' : ' + sel[o.name]); });
      var cat = priceNow();
      Cart.add({
        id: cur.handle, name: cur.name, variant: parts.join(' · '),
        price: finalPrice(cur, cat, sel),
        qty: 1, img: cur.images[0]
      });
      close();
    });
  }

  /* ======================================================================
     16. PAGE PERSONNALISATION
     ====================================================================== */
  function initCustom() {
    var tiers = $$('.tier[data-price]');
    if (!tiers.length) return;

    var price = 0, fileName = '';
    var recap = {
      taille: $('[data-recap="taille"]'),
      couleur: $('[data-recap="couleur"]'),
      texte: $('[data-recap="texte"]'),
      fichier: $('[data-recap="fichier"]'),
      total: $('[data-recap="total"]')
    };
    function setRow(el, v, fallback) {
      if (!el) return;
      el.textContent = v || fallback;
      el.parentElement.classList.toggle('empty', !v);
    }
    function syncRecap() {
      var hid = $('#tier-input');
      var col = $('#color-input');
      var txt = $('#text-input');
      setRow(recap.taille, hid && hid.value, 'à choisir');
      setRow(recap.couleur, col && col.value, 'à choisir');
      setRow(recap.texte, txt && txt.value.trim(), 'aucun');
      setRow(recap.fichier, fileName, 'aucun');
      // couleur spéciale : supplément selon le palier (data-special sur le palier choisi)
      var tierOn = $('.tier.on'), opt = col && col.selectedOptions && col.selectedOptions[0];
      var sur = tierOn && opt && opt.hasAttribute('data-special') ? parseFloat(tierOn.getAttribute('data-special')) || 0 : 0;
      var surRow = $('[data-recap-sur]');
      if (surRow) { surRow.hidden = !sur; setRow($('[data-recap="supplement"]'), sur ? '+' + fmt(sur) + ' CHF' : '', '—'); }
      var total = price ? price + sur : 0;
      if (recap.total) recap.total.textContent = total ? fmt(total) + ' CHF' : '—';
      var out = $('[data-tier-total]');
      if (out) out.textContent = total ? fmt(total) + ' CHF' : '—';
    }

    tiers.forEach(function (t) {
      t.addEventListener('click', function () {
        tiers.forEach(function (x) { x.classList.remove('on'); });
        t.classList.add('on');
        price = parseFloat(t.getAttribute('data-price')) || 0;
        var hid = $('#tier-input');
        if (hid) { hid.value = t.getAttribute('data-label'); clearError(hid); }
        syncRecap();
      });
    });
    ['#color-input', '#text-input'].forEach(function (sel) {
      var el = $(sel);
      if (el) el.addEventListener('input', syncRecap);
      if (el && el.tagName === 'SELECT') el.addEventListener('change', syncRecap);
    });

    var drop = $('.drop');
    if (!drop) { syncRecap(); return; }
    var input = $('#file-input');
    var OK = ['image/jpeg', 'image/png', 'image/webp'];
    var MAX = 12 * 1024 * 1024;

    function reset() {
      fileName = '';
      drop.classList.remove('filled');
      $('b', drop).textContent = 'Dépose ton fichier ici';
      $('span', drop).textContent = 'ou clique pour parcourir — JPG, PNG, 12 Mo max';
      if (input) input.value = '';
      syncRecap();
    }
    function accept(file) {
      if (OK.indexOf(file.type) < 0) {
        toast('Format refusé — JPG, PNG ou WebP');
        return;
      }
      if (file.size > MAX) {
        toast('Fichier trop lourd — 12 Mo maximum');
        return;
      }
      fileName = file.name;
      drop.classList.add('filled');
      $('b', drop).textContent = file.name;
      $('span', drop).textContent = Math.round(file.size / 1024) +
        ' Ko — fichier prêt pour la découpe.';
      syncRecap();
    }

    drop.addEventListener('click', function (ev) {
      if (ev.target.classList.contains('clear')) { ev.stopPropagation(); reset(); return; }
      if (input) input.click();
    });
    ['dragenter', 'dragover'].forEach(function (ev) {
      drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('over'); });
    });
    ['dragleave', 'drop'].forEach(function (ev) {
      drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('over'); });
    });
    drop.addEventListener('drop', function (e) {
      if (e.dataTransfer && e.dataTransfer.files.length) accept(e.dataTransfer.files[0]);
    });
    if (input) input.addEventListener('change', function () {
      if (input.files.length) accept(input.files[0]);
    });
    syncRecap();
  }

  /* ======================================================================
     17. VALIDATION DES FORMULAIRES
     Contrôle à la soumission, message sous le champ fautif, focus dessus.
     ====================================================================== */
  var RULES = {
    email: {
      test: function (v) { return /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(v.trim()); },
      msg: 'Adresse e-mail incomplète — il manque le @ ou le domaine.'
    },
    tel: {
      test: function (v) { return !v.trim() || /^[+()\d\s.-]{7,}$/.test(v.trim()); },
      msg: 'Numéro de téléphone invalide.'
    }
  };

  function fieldWrap(el) { return el.closest('.field') || el.parentElement; }

  function setError(el, msg) {
    var w = fieldWrap(el);
    w.classList.add('invalid');
    w.classList.remove('valid');
    var box = $('.field-error', w);
    if (!box) {
      box = document.createElement('div');
      box.className = 'field-error';
      box.innerHTML = '<i>◆</i><span></span>';
      (el.nextElementSibling && el.nextElementSibling.classList.contains('help'))
        ? el.nextElementSibling.before(box) : el.after(box);
    }
    $('span', box).textContent = msg;
    el.setAttribute('aria-invalid', 'true');
  }

  function clearError(el) {
    var w = fieldWrap(el);
    w.classList.remove('invalid');
    if (el.value && el.value.trim()) w.classList.add('valid');
    else w.classList.remove('valid');
    el.removeAttribute('aria-invalid');
  }

  function validateField(el) {
    var v = el.value == null ? '' : String(el.value);
    var required = el.hasAttribute('required');
    if (el.hasAttribute('data-need-tier') && !v.trim()) {
      setError(el, 'Choisis d\'abord un palier de taille dans la colonne de gauche (étape 1).');
      return false;
    }
    if (required && !v.trim()) {
      setError(el, el.getAttribute('data-required-msg') || (el.tagName === 'SELECT' ? 'Fais un choix dans la liste.' : 'Ce champ est obligatoire.'));
      return false;
    }
    var r = RULES[el.type];
    if (r && v.trim() && !r.test(v)) { setError(el, r.msg); return false; }
    if (el.hasAttribute('data-need-tier') && !v.trim()) {
      setError(el, 'Choisis d\'abord un palier de taille dans la colonne de gauche.');
      return false;
    }
    clearError(el);
    return true;
  }

  function initForms() {
    $$('form[data-demo]').forEach(function (f) {
      // sans novalidate, la bulle native du navigateur bloque avant notre contrôle
      f.setAttribute('novalidate', '');
      var fields = $$('input,textarea,select', f).filter(function (el) {
        return el.type !== 'file' && el.type !== 'hidden' && el.type !== 'submit';
      });

      fields.forEach(function (el) {
        el.addEventListener('input', function () {
          if (fieldWrap(el).classList.contains('invalid')) validateField(el);
        });
        el.addEventListener('blur', function () { if (el.value.trim()) validateField(el); });

        // compteur de caractères sur les zones de texte longues
        if (el.tagName === 'TEXTAREA' && !$('.counter', fieldWrap(el))) {
          var c = document.createElement('span');
          c.className = 'counter';
          fieldWrap(el).appendChild(c);
          var max = 1200;
          var sync = function () {
            c.textContent = el.value.length + ' / ' + max;
            c.classList.toggle('over', el.value.length > max);
          };
          el.addEventListener('input', sync);
          sync();
        }
      });

      f.addEventListener('submit', function (ev) {
        // formulaire branché sur Shopify (data-sk-shopify) et déjà validé : envoi réel (contact / client)
        if (f._skOk) { f._skOk = false; return; }
        ev.preventDefault();
        var bad = [];
        fields.forEach(function (el) { if (!validateField(el)) bad.push(el); });

        var alert = $('.form-alert', f);
        if (bad.length) {
          if (alert) {
            alert.classList.add('on');
            $('span', alert).textContent = bad.length > 1
              ? bad.length + ' champs sont à corriger avant l\'envoi.'
              : 'Un champ est à corriger avant l\'envoi.';
          }
          bad[0].focus();
          bad[0].scrollIntoView({ block: 'center', behavior: 'smooth' });
          return;
        }
        if (alert) alert.classList.remove('on');

        if (f.hasAttribute('data-sk-shopify')) {
          var sb = $('[type=submit]', f); if (sb) sb.setAttribute('aria-busy', 'true');
          f._skOk = true;
          if (f.requestSubmit) f.requestSubmit(); else HTMLFormElement.prototype.submit.call(f);
          return;
        }

        var done = f.parentElement.querySelector('.form-done');
        if (done) {
          f.style.display = 'none';
          done.classList.add('on');
          done.scrollIntoView({ block: 'center', behavior: 'smooth' });
        } else {
          toast('Formulaire valide — à brancher sur Shopify');
        }
      });
    });

    // retour de Shopify après envoi : ?contact_posted=true (contact) ou ?customer_posted=true (newsletter)
    var q = location.search;
    if (/[?&]contact_posted=true/.test(q)) {
      var cf = $('form[data-sk-shopify][action*="contact_form"]'), cd = cf && cf.parentElement.querySelector('.form-done');
      if (cd) { cf.style.display = 'none'; cd.classList.add('on'); setTimeout(function () { cd.scrollIntoView({ block: 'center' }); }, 300); }
    } else if (/[?&]customer_posted=true/.test(q)) {
      toast('Merci ! Ton code -10 % arrive par e-mail.');
    }
  }

  /* ======================================================================
     18. RECHERCHE INSTANTANÉE — ⌘K / Ctrl+K
     Index embarqué sur chaque page : produits, collections, pages.
     ====================================================================== */
  var findItems = null;   // recherche de la palette, réutilisée par la page 404
  function initPalette() {
    var raw = $('#search-index');
    if (!raw) return;
    var data = [];
    try { data = JSON.parse(raw.textContent); } catch (e) { return; }

    var box = document.createElement('div');
    box.id = 'palette';
    box.setAttribute('aria-hidden', 'true');
    box.innerHTML =
      '<div class="pal-box" role="dialog" aria-label="Recherche">' +
      '<div class="pal-in"><i>⌕</i>' +
      '<input type="text" placeholder="Cherche un sticker, une collection, une page…" aria-label="Recherche">' +
      '<kbd>Esc</kbd></div>' +
      '<div class="pal-list"></div>' +
      '<div class="pal-foot"><span><kbd>↑</kbd><kbd>↓</kbd> naviguer</span>' +
      '<span><kbd>Entrée</kbd> ouvrir</span><span><kbd>Esc</kbd> fermer</span></div></div>';
    document.body.appendChild(box);

    var input = $('input', box), list = $('.pal-list', box);
    var shown = [], sel = 0;

    var norm = function (v) {
      return (v || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    };
    var I18N = function () { return window.StickitI18n && window.StickitI18n.lang !== 'fr' ? window.StickitI18n : null; };
    var tr = function (s) { var i = I18N(); return i && s ? i.t(s) : s; };

    // mots tapés dans une autre langue (ou au singulier) → mots présents dans l'index
    var SYN = {
      casque: 'helmet helm helme casco caschi cascos', moto: 'motorcycle motorbike bike motorrad motocicletta motocicleta',
      coque: 'phone handy telefono telephone smartphone cellulare movil iphone case hulle', etoile: 'star stern stella estrella',
      croix: 'cross kreuz croce cruz', numero: 'number nummer startnummer course race rennen gara carrera',
      instagram: 'insta pseudo username name nom nome nombre', livraison: 'shipping delivery versand lieferung spedizione consegna envio',
      contact: 'kontakt contatto contacto', custom: 'perso personnalise personalized personalised eigenes personalizzato personalizado mesure',
      douane: 'customs zoll dogana aduana taxes', cgv: 'terms agb condizioni condiciones', stickers: 'sticker aufkleber adesivi adesivo pegatinas pegatina'
    };
    var ALT = {};
    Object.keys(SYN).forEach(function (fr) { SYN[fr].split(' ').forEach(function (w) { (ALT[w] = ALT[w] || []).push(fr); }); });
    var words = function (s) { return norm(s).split(/[^a-z0-9]+/).filter(Boolean); };

    // distance d'édition bornée (fautes de frappe : « akrapovik », « nollan »)
    function near(a, b, max) {
      if (Math.abs(a.length - b.length) > max) return false;
      var prev = [], cur, i, j;
      for (j = 0; j <= b.length; j++) prev[j] = j;
      for (i = 1; i <= a.length; i++) {
        cur = [i];
        for (j = 1; j <= b.length; j++) cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
        prev = cur;
      }
      return prev[b.length] <= max;
    }
    // 4 = mot exact, 2 = début ou morceau de mot, 1 = faute de frappe, 0 = absent
    function hit(w, hay, flat) {
      var alts = [w].concat(ALT[w] || []), best = 0;
      alts.forEach(function (a) {
        hay.forEach(function (h) {
          if (h === a) best = 4;
          else if (best < 2 && (h.indexOf(a) === 0 || (a.length >= 3 && h.indexOf(a) > 0))) best = 2;
          else if (!best && a.length >= 4 && near(a, h.slice(0, a.length + 1), a.length >= 8 ? 2 : 1)) best = 1;
        });
        if (best < 2 && a.length >= 4 && flat.indexOf(a) >= 0) best = 2;  // « quadlock », « rs660 »
      });
      return best;
    }

    var RANK = { Stickers: 0, Collections: 1, Pages: 2 };
    data.forEach(function (d, n) { d.n = n; });
    function score(d, q) {
      var title = words(d.t + ' ' + tr(d.t)), hay = title.concat(words([d.s, tr(d.s), d.k, d.g].join(' ')));
      var flat = hay.join(''), qs = q.split(/[^a-z0-9]+/).filter(Boolean), s = 0;
      for (var i = 0; i < qs.length; i++) {
        var h = hit(qs[i], title, flat);
        if (h) s += h * 10; else if ((h = hit(qs[i], hay, flat))) s += h * 4; else return -1;
      }
      var t = norm(tr(d.t)), f = norm(d.t);
      if (t.indexOf(q) === 0 || f.indexOf(q) === 0) s += 30;
      else if (t.indexOf(q) > 0 || f.indexOf(q) > 0) s += 15;
      return s;
    }

    function mark(text, q) {
      var low = norm(text), out = '', last = 0, spans = [];
      q.split(/[^a-z0-9]+/).forEach(function (w) {
        if (w.length < 2) return;
        var i = low.indexOf(w);
        if (i >= 0) spans.push([i, i + w.length]);
      });
      spans.sort(function (a, b) { return a[0] - b[0]; }).forEach(function (r) {
        if (r[0] < last) return;
        out += esc(text.slice(last, r[0])) + '<mark>' + esc(text.slice(r[0], r[1])) + '</mark>';
        last = r[1];
      });
      return out + esc(text.slice(last));
    }

    function find(q) {
      var all = data.map(function (d) { return { d: d, s: score(d, q) }; }).filter(function (x) { return x.s >= 0; });
      var qs = q.split(/[^a-z0-9]+/).filter(Boolean);
      if (!all.length && qs.length > 1) {
        // aucun résultat n'a tous les mots (« akrapovic long noir ») : on classe par mots trouvés
        all = data.map(function (d) {
          var n = 0, s = 0;
          qs.forEach(function (w) { var x = score(d, w); if (x >= 0) { n++; s += x; } });
          return { d: d, s: n ? n * 1000 + s : -1 };
        }).filter(function (x) { return x.s >= 0; });
      }
      return all.sort(function (a, b) { return (RANK[a.d.g] || 0) - (RANK[b.d.g] || 0) || b.s - a.s || a.d.n - b.d.n; })
        .map(function (x) { return x.d; });
    }
    findItems = function (q) { return find(norm(q)); };

    function render(q) {
      var res;
      if (!q) {
        // ouverture : les collections, puis les modèles
        res = data.filter(function (d) { return d.g !== 'Pages'; })
          .sort(function (a, b) { return (RANK[b.g] || 0) - (RANK[a.g] || 0) || a.n - b.n; }).slice(0, 12);
      } else {
        res = find(q).slice(0, 12);
      }
      shown = res; sel = 0;

      if (!res.length) {
        list.innerHTML = '<div class="pal-empty"><b>Rien trouvé</b>' +
          'Aucun modèle ne porte ce nom — mais on peut le découper pour toi.</div>' +
          '<div class="pal-item" data-u="/pages/ton-custom"><div class="ph"></div>' +
          '<div class="tx"><b>Créer mon sticker</b><span>Ton design, découpé sur mesure</span></div></div>';
        bind();
        return;
      }
      var html = '', last = '';
      res.forEach(function (d, i) {
        if (d.g !== last) { html += '<div class="pal-group">' + esc(d.g) + '</div>'; last = d.g; }
        // titre et sous-titre traduits ici (le surlignage coupe le texte en morceaux) : i18n ne les retouche pas
        html += '<div class="pal-item' + (i === 0 ? ' sel' : '') + '" data-u="' + esc(d.u) + '">' +
          '<div class="ph">' + (d.i ? '<img src="' + esc(d.i) + '" alt="" loading="lazy">' : '') + '</div>' +
          '<div class="tx"><b translate="no">' + mark(tr(d.t), q) + '</b><span translate="no">' + esc(tr(d.s || d.g)) + '</span></div>' +
          (d.p ? '<div class="pr">' + esc(d.p) + '</div>' : '') + '</div>';
      });
      list.innerHTML = html;
      bind();
    }
    addEventListener('stickit:lang', function () { if (box.classList.contains('on')) render(norm(input.value.trim())); });

    function bind() {
      $$('.pal-item', list).forEach(function (el, i) {
        el.addEventListener('click', function () { go(el.getAttribute('data-u')); });
        el.addEventListener('mouseenter', function () {
          $$('.pal-item', list).forEach(function (x) { x.classList.remove('sel'); });
          el.classList.add('sel'); sel = i;
        });
      });
    }
    function go(u) { if (u) location.href = u; }
    function move(step) {
      var items = $$('.pal-item', list);
      if (!items.length) return;
      sel = (sel + step + items.length) % items.length;
      items.forEach(function (x, i) { x.classList.toggle('sel', i === sel); });
      items[sel].scrollIntoView({ block: 'nearest' });
    }

    function open(q) {
      box.classList.add('on');
      box.setAttribute('aria-hidden', 'false');
      input.value = q || '';
      render(norm(input.value.trim()));
      setTimeout(function () { input.focus(); }, 60);
    }
    function close() { box.classList.remove('on'); box.setAttribute('aria-hidden', 'true'); }

    input.addEventListener('input', function () { render(norm(input.value.trim())); });
    input.addEventListener('keydown', function (ev) {
      if (ev.key === 'ArrowDown') { ev.preventDefault(); move(1); }
      else if (ev.key === 'ArrowUp') { ev.preventDefault(); move(-1); }
      else if (ev.key === 'Enter') {
        ev.preventDefault();
        var it = $$('.pal-item', list)[sel];
        if (it) go(it.getAttribute('data-u'));
      }
    });
    box.addEventListener('click', function (ev) { if (ev.target === box) close(); });
    addEventListener('keydown', function (ev) {
      if ((ev.metaKey || ev.ctrlKey) && ev.key.toLowerCase() === 'k') { ev.preventDefault(); open(); }
      else if (ev.key === 'Escape' && box.classList.contains('on')) close();
      else if (ev.key === '/' && document.activeElement === document.body) { ev.preventDefault(); open(); }
    });
    $$('[data-search]').forEach(function (b) {
      b.addEventListener('click', function (ev) { ev.preventDefault(); open(b.getAttribute('data-search-q')); });
    });
  }

  /* ======================================================================
     21. GABARIT DE POSE — SIMULATEUR CASQUE
     Le casque est un tracé SVG ; le sticker est composé dans un canvas qui
     partage le même repère (viewBox 420x340). On peut donc découper le
     visuel sur la coque, le teinter selon le vinyle choisi, l'échelonner en
     centimètres réels et le déplacer à la souris ou au doigt.
     ====================================================================== */
  var HELM = {
    w: 420, h: 340, cmw: 34,   // le casque du gabarit fait 34 cm de long
    shell: 'M130,32 C208,6 306,36 348,104 C372,142 370,198 344,238 C328,262 308,274 288,270 ' +
           'C256,262 240,204 212,196 C182,188 166,242 146,280 C126,302 90,306 62,286 ' +
           'C40,272 28,250 26,222 C24,168 42,104 94,60 C106,50 116,40 130,32 Z'
  };

  /* Prépare l'oeuvre : détoure le fond uni si besoin, recadre sur la matière. */
  function prepArt(img) {
    var c = document.createElement('canvas');
    var w = img.naturalWidth || img.width, h = img.naturalHeight || img.height;
    if (!w || !h) return null;
    var max = 900, sc = Math.min(1, max / Math.max(w, h));
    c.width = Math.max(1, Math.round(w * sc));
    c.height = Math.max(1, Math.round(h * sc));
    var x = c.getContext('2d', { willReadFrequently: true });
    x.drawImage(img, 0, 0, c.width, c.height);

    var d;
    try { d = x.getImageData(0, 0, c.width, c.height); }
    catch (e) { return { c: c, w: c.width, h: c.height, raw: true }; }

    var p = d.data, n = p.length, i, tr = 0;
    for (i = 3; i < n; i += 4) { if (p[i] < 16) tr++; }

    if (tr / (n / 4) < 0.05) {
      // Pas de transparence : on tente de retirer un fond uni (planche blanche).
      var W = c.width, H = c.height;
      var corners = [0, (W - 1) * 4, (H - 1) * W * 4, (H * W - 1) * 4];
      var r = 0, g = 0, b = 0, k;
      for (k = 0; k < 4; k++) { r += p[corners[k]]; g += p[corners[k] + 1]; b += p[corners[k] + 2]; }
      r /= 4; g /= 4; b /= 4;
      var uniform = true;
      for (k = 0; k < 4; k++) {
        if (Math.abs(p[corners[k]] - r) > 20 || Math.abs(p[corners[k] + 1] - g) > 20 ||
            Math.abs(p[corners[k] + 2] - b) > 20) { uniform = false; break; }
      }
      if (uniform) {
        for (i = 0; i < n; i += 4) {
          var dd = Math.abs(p[i] - r) + Math.abs(p[i + 1] - g) + Math.abs(p[i + 2] - b);
          if (dd < 60) p[i + 3] = 0;
          else if (dd < 118) p[i + 3] = Math.round(p[i + 3] * (dd - 60) / 58);
        }
        x.putImageData(d, 0, 0);
        d = x.getImageData(0, 0, c.width, c.height);
        p = d.data;
      }
    }

    // Recadrage sur la matière : l'échelle en cm devient juste.
    var minX = c.width, minY = c.height, maxX = -1, maxY = -1, px, py;
    for (py = 0; py < c.height; py++) {
      for (px = 0; px < c.width; px++) {
        if (p[(py * c.width + px) * 4 + 3] > 12) {
          if (px < minX) minX = px;
          if (px > maxX) maxX = px;
          if (py < minY) minY = py;
          if (py > maxY) maxY = py;
        }
      }
    }
    if (maxX < 0) return { c: c, w: c.width, h: c.height };
    var cw = maxX - minX + 1, ch = maxY - minY + 1;
    if (cw < c.width - 2 || ch < c.height - 2) {
      var t = document.createElement('canvas');
      t.width = cw; t.height = ch;
      t.getContext('2d').drawImage(c, minX, minY, cw, ch, 0, 0, cw, ch);
      return { c: t, w: cw, h: ch };
    }
    return { c: c, w: c.width, h: c.height };
  }

  /* Teinte l'oeuvre selon la nature du vinyle. */
  function tintArt(art, color, kind) {
    if (art.raw || !color || kind === 'none') return art.c;
    var t = document.createElement('canvas');
    t.width = art.w; t.height = art.h;
    var x = t.getContext('2d');
    x.drawImage(art.c, 0, 0);
    x.globalCompositeOperation = 'source-in';

    var g;
    if (kind === 'holo') {
      g = x.createLinearGradient(0, art.h, art.w, 0);
      g.addColorStop(0, '#8FD9FF'); g.addColorStop(.26, '#C9A8FF');
      g.addColorStop(.5, '#FFB3D9'); g.addColorStop(.74, '#FFE49A');
      g.addColorStop(1, '#9BFFD0');
      x.fillStyle = g;
    } else if (kind === 'gold' || kind === 'silver' || kind === 'reflect') {
      var base = kind === 'gold' ? ['#7A5F1E', '#F3DC94', '#B08D2E']
        : kind === 'silver' ? ['#5E5E66', '#E6E6EC', '#84848E']
          : ['#9C9CA6', '#FFFFFF', '#B8B8C2'];
      g = x.createLinearGradient(0, 0, art.w, art.h);
      g.addColorStop(0, base[0]); g.addColorStop(.42, base[1]);
      g.addColorStop(.58, base[1]); g.addColorStop(1, base[2]);
      x.fillStyle = g;
    } else {
      x.fillStyle = color;
    }
    x.fillRect(0, 0, art.w, art.h);

    if (kind === 'matte') { x.globalCompositeOperation = 'source-atop'; x.fillStyle = 'rgba(0,0,0,.14)'; x.fillRect(0, 0, art.w, art.h); }
    return t;
  }

  function initSim() {
    $$('[data-sim]').forEach(function (sim) {
      var plate = $('[data-sim-plate]', sim);
      var cv = $('[data-sim-canvas]', sim);
      if (!plate || !cv) return;
      var ctx = cv.getContext('2d');
      var shellPath = null;
      try { shellPath = new Path2D(HELM.shell); } catch (e) { shellPath = null; }

      var items = [];
      try { items = JSON.parse(sim.getAttribute('data-sim-items') || '[]'); } catch (e) { items = []; }
      if (!items.length) return;

      var st = {
        i: 0, x: .66, y: .48, cm: parseFloat(sim.getAttribute('data-sim-cm')) || 21,
        color: '#FFFFFF', kind: 'flat', text: '', flip: false
      };
      var cache = {}, art = null, tinted = null, dirty = true;

      /* -------------------------------------------------- chargement image */
      function load(k) {
        var url = items[k].img;
        if (cache[url]) { art = cache[url]; tinted = null; dirty = true; render(); return; }
        var probe = new Image();
        probe.crossOrigin = 'anonymous';
        probe.onload = function () { done(probe); };
        probe.onerror = function () {
          var plain = new Image();
          plain.onload = function () { done(plain); };
          plain.onerror = function () { art = null; dirty = true; render(); };
          plain.src = url;
        };
        probe.src = url;

        function done(img) {
          var a = prepArt(img);
          if (a) { cache[url] = a; art = a; }
          tinted = null; dirty = true; render();
        }
      }

      /* --------------------------------------------------------- rendu */
      function render() {
        var r = plate.getBoundingClientRect();
        if (!r.width) return;
        var dpr = Math.min(2, window.devicePixelRatio || 1);
        var cw = Math.round(r.width * dpr), ch = Math.round(r.height * dpr);
        if (cv.width !== cw || cv.height !== ch) { cv.width = cw; cv.height = ch; }
        var s = (r.width / HELM.w) * dpr;
        ctx.setTransform(s, 0, 0, s, 0, 0);
        ctx.clearRect(0, 0, HELM.w, HELM.h);
        if (!art) return;

        if (dirty || !tinted) { tinted = tintArt(art, st.color, st.kind); dirty = false; }

        var ppcm = HELM.w / HELM.cmw;
        var long = Math.max(art.w, art.h);
        var w = art.w / long * st.cm * ppcm;
        var h = art.h / long * st.cm * ppcm;
        var cx = st.x * HELM.w, cy = st.y * HELM.h;

        ctx.save();
        // Espace miroir quand on regarde le profil droit : la coque bascule,
        // mais le visuel et le texte restent lisibles dans le bon sens.
        if (st.flip) { ctx.translate(HELM.w, 0); ctx.scale(-1, 1); }
        if (shellPath) ctx.clip(shellPath);
        ctx.globalAlpha = .97;
        ctx.save();
        ctx.translate(cx, cy);
        if (st.flip) ctx.scale(-1, 1);
        ctx.drawImage(tinted, -w / 2, -h / 2, w, h);
        ctx.restore();

        if (st.text) {
          // Le pseudo se pose sur la mentonnière, à l'écart du visuel principal.
          var txt = st.text.toUpperCase();
          var fs = 26;
          ctx.font = '700 ' + fs + "px Anton, 'Arial Narrow', sans-serif";
          var tw = ctx.measureText(txt).width;
          var max = 118;
          if (tw > max) { fs = Math.max(11, fs * max / tw); ctx.font = '700 ' + fs.toFixed(1) + "px Anton, 'Arial Narrow', sans-serif"; }
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';
          if (st.kind === 'holo') {
            var gt = ctx.createLinearGradient(52, 0, 172, 0);
            gt.addColorStop(0, '#8FD9FF'); gt.addColorStop(.5, '#FFB3D9'); gt.addColorStop(1, '#9BFFD0');
            ctx.fillStyle = gt;
          } else { ctx.fillStyle = st.color; }
          ctx.save();
          ctx.translate(112, 244);
          if (st.flip) ctx.scale(-1, 1);
          ctx.rotate(-0.17);
          ctx.fillText(txt, 0, 0);
          ctx.restore();
        }
        ctx.restore();
      }

      /* ------------------------------------------------------- interactions */
      function place(ev) {
        var r = plate.getBoundingClientRect();
        var nx = (ev.clientX - r.left) / r.width;
        var ny = (ev.clientY - r.top) / r.height;
        if (st.flip) nx = 1 - nx;
        st.x = clamp(nx, .08, .94);
        st.y = clamp(ny, .08, .92);
        plate.classList.add('placed');
        render();
      }
      var down = false;
      plate.addEventListener('pointerdown', function (ev) {
        down = true; plate.classList.add('dragging');
        if (plate.setPointerCapture) { try { plate.setPointerCapture(ev.pointerId); } catch (e) {} }
        place(ev);
      });
      plate.addEventListener('pointermove', function (ev) { if (down) { ev.preventDefault(); place(ev); } });
      ['pointerup', 'pointercancel'].forEach(function (t) {
        plate.addEventListener(t, function () { down = false; plate.classList.remove('dragging'); });
      });

      $$('[data-sim-side]', sim).forEach(function (b) {
        b.addEventListener('click', function () {
          $$('[data-sim-side]', sim).forEach(function (o) { o.classList.remove('on'); });
          b.classList.add('on');
          st.flip = b.getAttribute('data-sim-side') === 'r';
          plate.classList.toggle('flip', st.flip);
          render();
        });
      });

      $$('[data-sim-item]', sim).forEach(function (b) {
        b.addEventListener('click', function () {
          $$('[data-sim-item]', sim).forEach(function (o) { o.classList.remove('on'); });
          b.classList.add('on');
          st.i = parseInt(b.getAttribute('data-sim-item'), 10) || 0;
          load(st.i);
        });
      });

      $$('[data-sim-color]', sim).forEach(function (b) {
        b.addEventListener('click', function () {
          $$('[data-sim-color]', sim).forEach(function (o) { o.classList.remove('on'); });
          b.classList.add('on');
          setColor(b.style.background || '#FFFFFF', b.getAttribute('data-ckind') || 'flat');
        });
      });

      $$('[data-shell]', sim).forEach(function (b) {
        b.addEventListener('click', function () {
          $$('[data-shell]', sim).forEach(function (o) { o.classList.remove('on'); });
          b.classList.add('on');
          var v = (b.getAttribute('data-shell') || '').split('|');
          sim.style.setProperty('--shell', v[0]);
          sim.style.setProperty('--shell-line', v[1] || v[0]);
        });
      });

      var slider = $('[data-sim-cm-input]', sim), out = $('[data-sim-out]', sim);
      if (slider) {
        slider.addEventListener('input', function () {
          st.cm = parseFloat(slider.value);
          if (out) out.textContent = String(st.cm).replace('.0', '') + ' cm';
          render();
        });
      }
      var reset = $('[data-sim-reset]', sim);
      if (reset) {
        reset.addEventListener('click', function () {
          st.x = .66; st.y = .48;
          if (slider) { slider.value = sim.getAttribute('data-sim-cm') || 21; slider.dispatchEvent(new Event('input')); }
          plate.classList.remove('placed');
          render();
        });
      }

      function setColor(css, kind) {
        // Un dégradé CSS (holographique) ne sert pas de couleur de remplissage.
        st.color = /gradient/.test(css) ? '#DCD6C9' : (css || '#FFFFFF');
        st.kind = kind || 'flat';
        dirty = true;
        render();
      }

      /* --- mode fiche produit : le gabarit suit les options du produit --- */
      if (sim.getAttribute('data-sim') === 'pdp') {
        var pdp = $('[data-pdp]');
        if (pdp) {
          var sw = $$('.swatches button', pdp);
          var pick = function (b) { setColor(b.getAttribute('data-color') || b.style.background, b.getAttribute('data-ckind') || 'flat'); };
          sw.forEach(function (b) { b.addEventListener('click', function () { pick(b); }); });
          var on = sw.filter(function (b) { return b.classList.contains('on'); })[0] || sw[0];
          if (on) pick(on);

          if (sim.getAttribute('data-sim-text')) {
            var inp = $('[data-custom]', pdp);
            if (inp) {
              inp.addEventListener('input', function () {
                st.text = inp.value.slice(0, 22);
                render();
              });
            }
          }
          var sizes = $$('.sizes button', pdp);
          sizes.forEach(function (b) {
            b.addEventListener('click', function () {
              var m = (b.getAttribute('data-val') || '').match(/(\d+(?:[.,]\d+)?)\s*cm/i);
              if (m && slider) {
                slider.value = clamp(parseFloat(m[1].replace(',', '.')), 12, 28);
                slider.dispatchEvent(new Event('input'));
              }
            });
          });
        }
      }

      var ro = null;
      if (window.ResizeObserver) { ro = new ResizeObserver(function () { render(); }); ro.observe(plate); }
      else { addEventListener('resize', render, { passive: true }); }

      load(0);
      render();
    });
  }

  /* 11c. CASQUE CUSTOM : voir assets/js/helmet-custom.js (transformation façon Photoshop). */

  /* petites cartes produit (vus récemment, page 404) à partir de l'index de recherche */
  function miniCards(list) {
    return list.map(function (d) {
      var img = String(d.i || '').replace(/\.webp(\?|$)/, '-fill-640x640.webp$1');
      return '<div class="pcard" data-handle="' + esc(d.u.split('/').pop()) + '"><a class="pcard-link" href="' + esc(d.u) + '"><div class="ph">' +
        (img ? '<img class="main" src="' + esc(img) + '" data-full="' + esc(d.i) + '" alt="" width="640" height="640" loading="lazy" decoding="async">' : '') +
        '</div><div class="b"><h3>' + esc(d.t) + '</h3>' + (d.p ? '<div class="pr"><b>' + esc(d.p) + '</b></div>' : '') + '</div></a></div>';
    }).join('');
  }
  function miniCardsFallback(root) {
    $$('img[data-full]', root).forEach(function (im) {
      im.addEventListener('error', function () { if (im.src !== im.getAttribute('data-full')) im.src = im.getAttribute('data-full'); }, { once: true });
    });
  }

  /* ======================================================================
     11e. PAGE 404
     Les mots de l'adresse cassée (ancien lien, faute de frappe) servent de recherche :
     bouton « Chercher » prérempli et premiers résultats en cartes.
     ====================================================================== */
  function initNotFound() {
    var box = $('[data-404]');
    if (!box) return;
    var STOP = /^(products?|product-page|collections?|pages?|blogs?|shop|boutique|all|html?|php|fr|en|de|it|es|www|index|item|items|category|categorie|sticker|stickers)$/;
    var q = decodeURIComponent(location.pathname).toLowerCase().split(/[\/\-_+.\s]+/)
      .filter(function (w) { return w && !STOP.test(w) && !/^\d+$/.test(w) && w.length > 1; }).slice(-4).join(' ');
    var res = q && findItems ? findItems(q).filter(function (d) { return d.g === 'Stickers'; }) : [];
    var btn = $('[data-search-q]', box);
    if (btn && q) {
      btn.setAttribute('data-search-q', q);
      var qq = $('[data-404-q]', btn);
      if (qq) { qq.textContent = '« ' + q + ' »'; qq.hidden = false; }
    }
    var idx = [], found = res.length > 0;
    try { idx = JSON.parse(($('#search-index') || {}).textContent || '[]'); } catch (e) { idx = []; }
    idx.forEach(function (d) { if (d.g === 'Stickers' && res.indexOf(d) < 0 && !res.some(function (r) { return r.u === d.u; })) res.push(d); });
    var sec = $('[data-404-sugg]');
    if (!sec || !res.length) return;
    $('[data-404-t]', sec).textContent = found ? 'Tu cherchais peut-être' : 'Nos modèles';
    $('.grid', sec).innerHTML = miniCards(res.slice(0, 4));
    miniCardsFallback(sec);
    sec.hidden = false;
  }

  /* ======================================================================
     11d. VUS RÉCEMMENT — fiches produits
     Chaque fiche visitée est notée (8 max, la plus récente d'abord) ; sous
     « Ça peut te plaire », les 4 dernières autres fiches, prises dans l'index de recherche.
     ====================================================================== */
  function initRecent() {
    var m = /^\/products\/([^\/?#]+)/.exec(location.pathname);
    if (!m || !$('[data-pdp]')) return;
    var KEY = 'stickit_recent_v1', here = decodeURIComponent(m[1]), seen = [], idx = [];
    try { seen = JSON.parse(Store.get(KEY) || '[]'); } catch (e) { seen = []; }
    if (!Array.isArray(seen)) seen = [];
    seen = [here].concat(seen.filter(function (h) { return h !== here; })).slice(0, 8);
    Store.set(KEY, JSON.stringify(seen));
    try { idx = JSON.parse(($('#search-index') || {}).textContent || '[]'); } catch (e) { return; }
    var byU = {};
    idx.forEach(function (d) { if (d.g === 'Stickers') byU[d.u] = d; });
    var list = seen.slice(1).map(function (h) { return byU['/products/' + h]; }).filter(Boolean).slice(0, 4);
    if (!list.length) return;
    var secs = $$('main .sec'), after = secs[secs.length - 1];
    if (!after) return;
    var sec = document.createElement('section');
    sec.className = 'sec sk-recent';
    sec.innerHTML = '<div class="wrap"><div class="sec-head"><div><p class="eyebrow">Ton historique</p><h2 class="disp">Vus récemment</h2></div>' +
      '<button class="more" type="button" data-recent-clear>Effacer</button></div><div class="grid">' +
      miniCards(list) + '</div></div>';
    after.parentNode.insertBefore(sec, after.nextSibling);
    miniCardsFallback(sec);
    $('[data-recent-clear]', sec).addEventListener('click', function () {
      Store.set(KEY, JSON.stringify([here]));
      sec.parentNode.removeChild(sec);
    });
  }

  /* ====================================================================== */
  /* ======================================================================
     11f. DÉLAI DE LIVRAISON ESTIMÉ (fiches produit)
     Zone selon le pays Shopify du visiteur (window.SK_COUNTRY, layout), en jours ouvrés.
     48 h de production comprises (CH/LI : 3-4 j ; UE et reste du monde : comme Merchant Center).
     ====================================================================== */
  function initEta() {
    var cta = $('.pdp-info > .pdp-cta'), m = /^\/products\/([^\/?#]+)/.exec(location.pathname), country = window.SK_COUNTRY;
    if (!cta || !m || !country || !window.Intl) return;
    if (m[1] === 'sticker-personnalise') return;   // production après validation du rendu
    var EU = 'AT BE BG CZ DE DK EE ES FI FR GR HR HU IE IT LT LU LV MT NL PL PT RO SE SI SK'.split(' ');
    var days = /^(CH|LI)$/.test(country) ? [3, 4] : EU.indexOf(country) >= 0 ? [6, 9] : [9, 14];
    var LOCALE = { fr: 'fr-CH', en: 'en-GB', de: 'de-CH', it: 'it-CH', es: 'es-ES' };
    function addDays(n) {
      var d = new Date();
      while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) n--; }
      return d;
    }
    var el = document.createElement('div');
    el.className = 'pdp-eta';
    el.innerHTML = '<b>Livraison estimée</b><span data-i18n-skip data-eta></span><small>Production 48 h comprise, en jours ouvrés.</small>';
    cta.parentNode.insertBefore(el, cta.nextSibling);
    function render() {
      var lang = (window.StickitI18n && window.StickitI18n.lang) || 'fr';
      var loc = LOCALE[lang] || 'fr-CH';
      var f = new Intl.DateTimeFormat(loc, { weekday: 'short', day: 'numeric', month: 'short' });
      var txt = f.format(addDays(days[0])) + ' – ' + f.format(addDays(days[1]));
      try { txt += ' · ' + new Intl.DisplayNames([loc], { type: 'region' }).of(country); } catch (e) {}
      $('[data-eta]', el).textContent = txt;
    }
    render();
    window.addEventListener('stickit:lang', render);
  }

  /* ======================================================================
     11g. FAVORIS
     Cœur sur les cartes et les fiches, liste dans un panneau ouvert depuis l'en-tête.
     Gardés dans le navigateur (stickit_favs_v1), cartes tirées de #search-index.
     ====================================================================== */
  function initFavs() {
    var KEY = 'stickit_favs_v1', favs = [], byH = {};
    try { favs = JSON.parse(Store.get(KEY) || '[]'); } catch (e) { favs = []; }
    if (!Array.isArray(favs)) favs = [];
    try {
      JSON.parse(($('#search-index') || {}).textContent || '[]').forEach(function (d) {
        if (d.g === 'Stickers') byH[d.u.split('/').pop()] = d;
      });
    } catch (e) { return; }
    favs = favs.filter(function (h) { return byH[h]; });
    var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.5s-7.5-4.6-9.3-9.2C1.5 8 3.5 4.5 7 4.5c2.1 0 3.8 1.1 5 3 1.2-1.9 2.9-3 5-3 3.5 0 5.5 3.5 4.3 6.8-1.8 4.6-9.3 9.2-9.3 9.2z"/></svg>';
    function btnHtml(h) {
      return '<button class="sk-fav" type="button" data-fav="' + esc(h) + '" aria-label="Favori" aria-pressed="' + (favs.indexOf(h) >= 0) + '">' + HEART + '</button>';
    }
    function decorate(root) {
      $$('.pcard', root).forEach(function (c) {
        if ($('[data-fav]', c)) return;
        var a = $('.pcard-link', c), h = c.getAttribute('data-handle') || (a && (a.getAttribute('href') || '').split('?')[0].split('/').pop());
        if (h && byH[h]) ($('.ph', c) || c).insertAdjacentHTML('beforeend', btnHtml(h));
      });
    }
    decorate(document);
    var m = /^\/products\/([^\/?#]+)/.exec(location.pathname), gal = $('.gal-main');
    if (m && gal && byH[m[1]]) gal.insertAdjacentHTML('beforeend', btnHtml(m[1]));

    var open = document.createElement('button');
    open.className = 'sk-favbtn'; open.type = 'button'; open.setAttribute('aria-label', 'Mes favoris');
    open.innerHTML = HEART + '<span class="sk-favn" hidden></span>';
    var bag = $('.site-head .bag');
    if (bag) bag.parentNode.insertBefore(open, bag);

    var box = document.createElement('div');
    box.id = 'sk-favs'; box.hidden = true;
    box.innerHTML = '<div class="sk-favs-back" data-favs-close></div><aside class="sk-favs-panel" role="dialog" aria-modal="true" aria-label="Mes favoris">' +
      '<div class="sk-favs-h"><h3>Mes favoris</h3><button type="button" data-favs-close aria-label="Fermer">×</button></div><div class="sk-favs-b"></div></aside>';
    document.body.appendChild(box);
    var body = $('.sk-favs-b', box);

    function count() {
      var n = $('.sk-favn', open);
      n.textContent = favs.length; n.hidden = !favs.length;
    }
    function fill() {
      body.innerHTML = favs.length
        ? '<div class="grid">' + miniCards(favs.map(function (h) { return byH[h]; })) + '</div>'
        : "<p class=\"sk-favs-empty\">Aucun favori pour l'instant. Touche le cœur d'un produit pour le retrouver ici.</p>";
      miniCardsFallback(body);
      decorate(body);
    }
    function show(on) {
      box.hidden = !on;
      document.documentElement.classList.toggle('sk-favs-on', on);
      if (on) { fill(); $('.sk-favs-h button', box).focus(); } else open.focus();
    }
    count();
    open.addEventListener('click', function () { show(true); });
    document.addEventListener('keydown', function (ev) { if (ev.key === 'Escape' && !box.hidden) show(false); });
    // en capture : le cœur est posé sur des zones cliquables (zoom de la galerie)
    document.addEventListener('click', function (ev) {
      if (!ev.target.closest) return;
      if (ev.target.closest('[data-favs-close]')) { show(false); return; }
      var b = ev.target.closest('[data-fav]');
      if (!b) return;
      ev.preventDefault(); ev.stopPropagation();
      var h = b.getAttribute('data-fav'), i = favs.indexOf(h);
      if (i >= 0) favs.splice(i, 1); else favs.unshift(h);
      Store.set(KEY, JSON.stringify(favs));
      $$('[data-fav]').forEach(function (x) {
        if (x.getAttribute('data-fav') === h) x.setAttribute('aria-pressed', String(i < 0));
      });
      count();
      if (!box.hidden) fill();
    }, true);
  }

  function boot() {
    // chaque module démarre isolément : une erreur dans l'un (élément absent sur une page Shopify…)
    // ne bloque plus les suivants — avant, les apparitions (.reveal) restaient invisibles
    [initSplit, initChrome, initPreloader, initCursor, initSmoke, initReveal, initCounters, initTilt,
     initMagnetic, initMarquee, initScramble, initParallax, initBgVideo, initHeader, initCart, initPDP,
     initShop, initCustom, initSim, initForms, initPalette, initRecent, initNotFound, initEta, initFavs].forEach(function (fn) {
      try { fn(); } catch (e) { if (window.console) console.error('[stickit] ' + fn.name, e); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.StickIt = { cart: Cart, toast: toast };
})();
